/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/company/service.proto" (package "rd.api.company", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CompanyService } from "./service_pb";
import type { ListPricingRegionsForCompanyRes } from "./service_pb";
import type { ListPricingRegionsForCompanyReq } from "./service_pb";
import type { ReorderPricingRegionsRes } from "./service_pb";
import type { ReorderPricingRegionsReq } from "./service_pb";
import type { DeactivatePricingRegionRes } from "./service_pb";
import type { DeactivatePricingRegionReq } from "./service_pb";
import type { UpdateDefaultPricingRegionRes } from "./service_pb";
import type { UpdateDefaultPricingRegionReq } from "./service_pb";
import type { UpdatePricingRegionNameRes } from "./service_pb";
import type { UpdatePricingRegionNameReq } from "./service_pb";
import type { CreatePricingRegionRes } from "./service_pb";
import type { CreatePricingRegionReq } from "./service_pb";
import type { GetIsGiftCardsEnabledRes } from "./service_pb";
import type { GetIsGiftCardsEnabledReq } from "./service_pb";
import type { GetActiveTenderMethodCountRes } from "./service_pb";
import type { GetActiveTenderMethodCountReq } from "./service_pb";
import type { ReorderTenderMethodsRes } from "./service_pb";
import type { ReorderTenderMethodsReq } from "./service_pb";
import type { ActivateCustomTenderMethodRes } from "./service_pb";
import type { ActivateCustomTenderMethodReq } from "./service_pb";
import type { DeactivateCustomTenderMethodRes } from "./service_pb";
import type { DeactivateCustomTenderMethodReq } from "./service_pb";
import type { UpdateDefaultTenderMethodUsagesRes } from "./service_pb";
import type { UpdateDefaultTenderMethodUsagesReq } from "./service_pb";
import type { UpdateCustomTenderMethodRes } from "./service_pb";
import type { UpdateCustomTenderMethodReq } from "./service_pb";
import type { CreateCustomTenderMethodRes } from "./service_pb";
import type { CreateCustomTenderMethodReq } from "./service_pb";
import type { ListDrawerMethodsRes } from "./service_pb";
import type { ListDrawerMethodsReq } from "./service_pb";
import type { ListEntitiesForCompanyRes } from "./service_pb";
import type { ListEntitiesForCompanyReq } from "./service_pb";
import type { DeleteSaleFormRes } from "./service_pb";
import type { DeleteSaleFormReq } from "./service_pb";
import type { ListSaleFormsRes } from "./service_pb";
import type { ListSaleFormsReq } from "./service_pb";
import type { UpdateSaleFormRes } from "./service_pb";
import type { UpdateSaleFormReq } from "./service_pb";
import type { CreateSaleFormRes } from "./service_pb";
import type { CreateSaleFormReq } from "./service_pb";
import type { UpdateCostManagementSettingsRes } from "./service_pb";
import type { UpdateCostManagementSettingsReq } from "./service_pb";
import type { ReorderFinanceChargeSettingsRes } from "./service_pb";
import type { ReorderFinanceChargeSettingsReq } from "./service_pb";
import type { DeactivateFinanceChargeSettingRes } from "./service_pb";
import type { DeactivateFinanceChargeSettingReq } from "./service_pb";
import type { ListCustomersForFinanceChargeSettingRes } from "./service_pb";
import type { ListCustomersForFinanceChargeSettingReq } from "./service_pb";
import type { ListActiveFinanceChargeSettingsForCompanyRes } from "./service_pb";
import type { ListActiveFinanceChargeSettingsForCompanyReq } from "./service_pb";
import type { UpdateFinanceChargeSettingRes } from "./service_pb";
import type { UpdateFinanceChargeSettingReq } from "./service_pb";
import type { CreateFinanceChargeSettingRes } from "./service_pb";
import type { CreateFinanceChargeSettingReq } from "./service_pb";
import type { GetPermissionsGroupsRes } from "./service_pb";
import type { GetPermissionsGroupsReq } from "./service_pb";
import type { UpdateCardSurchargeRateRes } from "./service_pb";
import type { UpdateCardSurchargeRateReq } from "./service_pb";
import type { GetCurrentUserIsAttributionEnabledRes } from "./service_pb";
import type { GetCurrentUserIsAttributionEnabledReq } from "./service_pb";
import type { GetCurrentUserRes } from "./service_pb";
import type { GetCurrentUserReq } from "./service_pb";
import type { ListCustomersForTierRes } from "./service_pb";
import type { ListCustomersForTierReq } from "./service_pb";
import type { ListPricingTiersForCompanyRes } from "./service_pb";
import type { ListPricingTiersForCompanyReq } from "./service_pb";
import type { ReorderPricingTiersRes } from "./service_pb";
import type { ReorderPricingTiersReq } from "./service_pb";
import type { DeletePricingTierRes } from "./service_pb";
import type { DeletePricingTierReq } from "./service_pb";
import type { UpdatePricingTierRes } from "./service_pb";
import type { UpdatePricingTierReq } from "./service_pb";
import type { CreatePricingTierRes } from "./service_pb";
import type { CreatePricingTierReq } from "./service_pb";
import type { ListCustomersForTermRes } from "./service_pb";
import type { ListCustomersForTermReq } from "./service_pb";
import type { ListFinancingTermsForCompanyRes } from "./service_pb";
import type { ListFinancingTermsForCompanyReq } from "./service_pb";
import type { ReorderFinancingTermsRes } from "./service_pb";
import type { ReorderFinancingTermsReq } from "./service_pb";
import type { DeleteFinancingTermRes } from "./service_pb";
import type { DeleteFinancingTermReq } from "./service_pb";
import type { UpdateFinancingTermRes } from "./service_pb";
import type { UpdateFinancingTermReq } from "./service_pb";
import type { CreateFinancingTermRes } from "./service_pb";
import type { CreateFinancingTermReq } from "./service_pb";
import type { BulkUpsertFinelineRes } from "./service_pb";
import type { BulkUpsertFinelineReq } from "./service_pb";
import type { BulkUpsertClassesRes } from "./service_pb";
import type { BulkUpsertClassesReq } from "./service_pb";
import type { BulkUpsertDepartmentsRes } from "./service_pb";
import type { BulkUpsertDepartmentsReq } from "./service_pb";
import type { DeactivateProductCategoryV2Res } from "./service_pb";
import type { DeactivateProductCategoryV2Req } from "./service_pb";
import type { GetProductCategoryTreeRes } from "./service_pb";
import type { GetProductCategoryTreeReq } from "./service_pb";
import type { ListProductsForCategoryV2Res } from "./service_pb";
import type { ListProductsForCategoryV2Req } from "./service_pb";
import type { ListProductCategoriesForCompanyV2Res } from "./service_pb";
import type { ListProductCategoriesForCompanyV2Req } from "./service_pb";
import type { UpdateProductCategoryV2Res } from "./service_pb";
import type { UpdateProductCategoryV2Req } from "./service_pb";
import type { CreateProductCategoryV2Res } from "./service_pb";
import type { CreateProductCategoryV2Req } from "./service_pb";
import type { GetDefaultPaintCareFeesRes } from "./service_pb";
import type { GetDefaultPaintCareFeesReq } from "./service_pb";
import type { ListProductsForFeeRes } from "./service_pb";
import type { ListProductsForFeeReq } from "./service_pb";
import type { ListAdditionalFeesForCompanyRes } from "./service_pb";
import type { ListAdditionalFeesForCompanyReq } from "./service_pb";
import type { ReorderAdditionalFeesRes } from "./service_pb";
import type { ReorderAdditionalFeesReq } from "./service_pb";
import type { DeleteAdditionalFeeRes } from "./service_pb";
import type { DeleteAdditionalFeeReq } from "./service_pb";
import type { UpdateAdditionalFeeRes } from "./service_pb";
import type { UpdateAdditionalFeeReq } from "./service_pb";
import type { CreateAdditionalFeeRes } from "./service_pb";
import type { CreateAdditionalFeeReq } from "./service_pb";
import type { GetAgreementPDFForCompanyRes } from "./service_pb";
import type { GetAgreementPDFForCompanyReq } from "./service_pb";
import type { ListAgreementsForCompanyRes } from "./service_pb";
import type { ListAgreementsForCompanyReq } from "./service_pb";
import type { SetEntityDefaultPaymentMethodRes } from "./service_pb";
import type { SetEntityDefaultPaymentMethodReq } from "./service_pb";
import type { GetNeedsBillingPaymentMethodRes } from "./service_pb";
import type { GetNeedsBillingPaymentMethodReq } from "./service_pb";
import type { GetEntityBillingInfoRes } from "./service_pb";
import type { GetEntityBillingInfoReq } from "./service_pb";
import type { CreateCardSetupIntentForEntityRes } from "./service_pb";
import type { CreateCardSetupIntentForEntityReq } from "./service_pb";
import type { GetIsStripePaymentsReadyRes } from "./service_pb";
import type { GetIsStripePaymentsReadyReq } from "./service_pb";
import type { GetStripeAccountSessionRes } from "./service_pb";
import type { GetStripeAccountSessionReq } from "./service_pb";
import type { GetStripeLoginURLRes } from "./service_pb";
import type { GetStripeLoginURLReq } from "./service_pb";
import type { GetStripeOnboardingURLRes } from "./service_pb";
import type { GetStripeOnboardingURLReq } from "./service_pb";
import type { CanEditSaleUomRes } from "./service_pb";
import type { CanEditSaleUomReq } from "./service_pb";
import type { ListUnitsOfMeasureForCompanyRes } from "./service_pb";
import type { ListUnitsOfMeasureForCompanyReq } from "./service_pb";
import type { BulkUpsertUnitsOfMeasureRes } from "./service_pb";
import type { BulkUpsertUnitsOfMeasureReq } from "./service_pb";
import type { DeleteCompanyUnitOfMeasureRes } from "./service_pb";
import type { DeleteCompanyUnitOfMeasureReq } from "./service_pb";
import type { UpdateCompanyUnitOfMeasureRes } from "./service_pb";
import type { UpdateCompanyUnitOfMeasureReq } from "./service_pb";
import type { AddCompanyUnitOfMeasureRes } from "./service_pb";
import type { AddCompanyUnitOfMeasureReq } from "./service_pb";
import type { GetOrCreateCustomTaxRateForAddressRes } from "./service_pb";
import type { GetOrCreateCustomTaxRateForAddressReq } from "./service_pb";
import type { ListTaxRatesForLocationRes } from "./service_pb";
import type { ListTaxRatesForLocationReq } from "./service_pb";
import type { ListTaxRatesForCompanyRes } from "./service_pb";
import type { ListTaxRatesForCompanyReq } from "./service_pb";
import type { DeactivateCustomTaxRateRes } from "./service_pb";
import type { DeactivateCustomTaxRateReq } from "./service_pb";
import type { ReorderCustomTaxRatesRes } from "./service_pb";
import type { ReorderCustomTaxRatesReq } from "./service_pb";
import type { UpdateCustomTaxRateRes } from "./service_pb";
import type { UpdateCustomTaxRateReq } from "./service_pb";
import type { CreateCustomTaxRateRes } from "./service_pb";
import type { CreateCustomTaxRateReq } from "./service_pb";
import type { UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes } from "./service_pb";
import type { UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq } from "./service_pb";
import type { UpdateCompanyProductImageSettingsRes } from "./service_pb";
import type { UpdateCompanyProductImageSettingsReq } from "./service_pb";
import type { UpdateCompanyIsPricingByRegionEnabledRes } from "./service_pb";
import type { UpdateCompanyIsPricingByRegionEnabledReq } from "./service_pb";
import type { GetIsBankingPermittedRes } from "./service_pb";
import type { GetIsBankingPermittedReq } from "./service_pb";
import type { UpdateCompanyStartInventoryCountsAtOnHandRes } from "./service_pb";
import type { UpdateCompanyStartInventoryCountsAtOnHandReq } from "./service_pb";
import type { ValidateCompanyCustomEmailConfigRes } from "./service_pb";
import type { ValidateCompanyCustomEmailConfigReq } from "./service_pb";
import type { UpdateCompanyCustomEmailConfigRes } from "./service_pb";
import type { UpdateCompanyCustomEmailConfigReq } from "./service_pb";
import type { UpdateCompanyShouldRequireCustomerOnSaleRes } from "./service_pb";
import type { UpdateCompanyShouldRequireCustomerOnSaleReq } from "./service_pb";
import type { UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes } from "./service_pb";
import type { UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq } from "./service_pb";
import type { UpdateCompanyShouldRequireVoidReasonRes } from "./service_pb";
import type { UpdateCompanyShouldRequireVoidReasonReq } from "./service_pb";
import type { UpdateCompanyShouldAutoApplyCreditsOnStatementsRes } from "./service_pb";
import type { UpdateCompanyShouldAutoApplyCreditsOnStatementsReq } from "./service_pb";
import type { UpdateCompanyAllowDifferentFulfillmentLocationRes } from "./service_pb";
import type { UpdateCompanyAllowDifferentFulfillmentLocationReq } from "./service_pb";
import type { UpdateCompanyPreserveSaleProductPriceEditsRes } from "./service_pb";
import type { UpdateCompanyPreserveSaleProductPriceEditsReq } from "./service_pb";
import type { UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes } from "./service_pb";
import type { UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq } from "./service_pb";
import type { UpdateCompanyShouldAllowNonStockCostEditsRes } from "./service_pb";
import type { UpdateCompanyShouldAllowNonStockCostEditsReq } from "./service_pb";
import type { UpdateCompanyShouldAllowNonStockPriceCostEditsRes } from "./service_pb";
import type { UpdateCompanyShouldAllowNonStockPriceCostEditsReq } from "./service_pb";
import type { UpdateCompanyShouldAllowReturnsWithoutNoteRes } from "./service_pb";
import type { UpdateCompanyShouldAllowReturnsWithoutNoteReq } from "./service_pb";
import type { UpdateCompanyShouldHideReturnConfirmationRes } from "./service_pb";
import type { UpdateCompanyShouldHideReturnConfirmationReq } from "./service_pb";
import type { UpdateCompanyShouldAutoApplyReturnCreditsRes } from "./service_pb";
import type { UpdateCompanyShouldAutoApplyReturnCreditsReq } from "./service_pb";
import type { UpdateCompanyQuickPrintPrinterByLocationRes } from "./service_pb";
import type { UpdateCompanyQuickPrintPrinterByLocationReq } from "./service_pb";
import type { UpdateCompanyQuickPrintSettingsRes } from "./service_pb";
import type { UpdateCompanyQuickPrintSettingsReq } from "./service_pb";
import type { UpdateCompanyDefaultReceiptQuantityRes } from "./service_pb";
import type { UpdateCompanyDefaultReceiptQuantityReq } from "./service_pb";
import type { UpdateCompanyShouldSkipLinkingReturnsRes } from "./service_pb";
import type { UpdateCompanyShouldSkipLinkingReturnsReq } from "./service_pb";
import type { UpdateCompanyShouldWarnWhenSellingBelowCostRes } from "./service_pb";
import type { UpdateCompanyShouldWarnWhenSellingBelowCostReq } from "./service_pb";
import type { UpdateCompanyShouldShowInventoryNegativeWarningRes } from "./service_pb";
import type { UpdateCompanyShouldShowInventoryNegativeWarningReq } from "./service_pb";
import type { UpdateCompanyShouldShowAccountBalanceOnReceiptRes } from "./service_pb";
import type { UpdateCompanyShouldShowAccountBalanceOnReceiptReq } from "./service_pb";
import type { UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes } from "./service_pb";
import type { UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq } from "./service_pb";
import type { UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes } from "./service_pb";
import type { UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq } from "./service_pb";
import type { UpdateCompanyShouldSetOrderedProductQuantityToZeroRes } from "./service_pb";
import type { UpdateCompanyShouldSetOrderedProductQuantityToZeroReq } from "./service_pb";
import type { UpdateCompanyDefaultDepositRateRes } from "./service_pb";
import type { UpdateCompanyDefaultDepositRateReq } from "./service_pb";
import type { UpdateCompanyTaxRateModeRes } from "./service_pb";
import type { UpdateCompanyTaxRateModeReq } from "./service_pb";
import type { UpdateCompanyShouldPromptForAddressTaxRateRes } from "./service_pb";
import type { UpdateCompanyShouldPromptForAddressTaxRateReq } from "./service_pb";
import type { UpdateCompanyIsCartReaderSyncDisabledRes } from "./service_pb";
import type { UpdateCompanyIsCartReaderSyncDisabledReq } from "./service_pb";
import type { UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes } from "./service_pb";
import type { UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq } from "./service_pb";
import type { UpdateCompanyLoyaltyProgramPolicyRes } from "./service_pb";
import type { UpdateCompanyLoyaltyProgramPolicyReq } from "./service_pb";
import type { UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes } from "./service_pb";
import type { UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq } from "./service_pb";
import type { UpdateCompanyEcommerceSettingsRes } from "./service_pb";
import type { UpdateCompanyEcommerceSettingsReq } from "./service_pb";
import type { UpdateCompanyIsLoyaltyProgramEnabledRes } from "./service_pb";
import type { UpdateCompanyIsLoyaltyProgramEnabledReq } from "./service_pb";
import type { UpdateCompanyIsCardSurchargeTaxExemptRes } from "./service_pb";
import type { UpdateCompanyIsCardSurchargeTaxExemptReq } from "./service_pb";
import type { UpdateCompanyIsFinancingTermsShownOnInvoiceRes } from "./service_pb";
import type { UpdateCompanyIsFinancingTermsShownOnInvoiceReq } from "./service_pb";
import type { UpdateCompanyIsDesignatedClerkEnabledRes } from "./service_pb";
import type { UpdateCompanyIsDesignatedClerkEnabledReq } from "./service_pb";
import type { UpdateCompanyShouldHideCategoryBrowserRes } from "./service_pb";
import type { UpdateCompanyShouldHideCategoryBrowserReq } from "./service_pb";
import type { UpdateCompanyIsColorFormulaHiddenRes } from "./service_pb";
import type { UpdateCompanyIsColorFormulaHiddenReq } from "./service_pb";
import type { UpdateCompanyShouldShowCostsOnTransferPrintsRes } from "./service_pb";
import type { UpdateCompanyShouldShowCostsOnTransferPrintsReq } from "./service_pb";
import type { UpdateCompanyIsPriceShownOnWillCallRes } from "./service_pb";
import type { UpdateCompanyIsPriceShownOnWillCallReq } from "./service_pb";
import type { UpdateCompanyIsDiscountPercentageShownOnReceiptRes } from "./service_pb";
import type { UpdateCompanyIsDiscountPercentageShownOnReceiptReq } from "./service_pb";
import type { UpdateCompanyIsDiscountShownToCustomersRes } from "./service_pb";
import type { UpdateCompanyIsDiscountShownToCustomersReq } from "./service_pb";
import type { UpdateCompanyIsBmDataSharingEnabledRes } from "./service_pb";
import type { UpdateCompanyIsBmDataSharingEnabledReq } from "./service_pb";
import type { UpdateCompanyContractorRewardsSettingsRes } from "./service_pb";
import type { UpdateCompanyContractorRewardsSettingsReq } from "./service_pb";
import type { UpdateCompanyShouldAutoSubmitContractorRewardsRes } from "./service_pb";
import type { UpdateCompanyShouldAutoSubmitContractorRewardsReq } from "./service_pb";
import type { UpdateCompanyGeneralCommunicationsSettingsRes } from "./service_pb";
import type { UpdateCompanyGeneralCommunicationsSettingsReq } from "./service_pb";
import type { UpdateCompanySecuritySettingsRes } from "./service_pb";
import type { UpdateCompanySecuritySettingsReq } from "./service_pb";
import type { UpdateCompanyGeneralSettingsRes } from "./service_pb";
import type { UpdateCompanyGeneralSettingsReq } from "./service_pb";
import type { UpdateCompanyStatementSettingsRes } from "./service_pb";
import type { UpdateCompanyStatementSettingsReq } from "./service_pb";
import type { GetCompanyRes } from "./service_pb";
import type { GetCompanyReq } from "./service_pb";
import type { GetCompanyForSubdomainRes } from "./service_pb";
import type { GetCompanyForSubdomainReq } from "./service_pb";
import type { BulkUpsertStaffRes } from "./service_pb";
import type { BulkUpsertStaffReq } from "./service_pb";
import type { UpdateStaffPermissionsRes } from "./service_pb";
import type { UpdateStaffPermissionsReq } from "./service_pb";
import type { ListAuthorizedEndpointsRes } from "./service_pb";
import type { ListAuthorizedEndpointsReq } from "./service_pb";
import type { DeactivateStaffWebAuthnKeysRes } from "./service_pb";
import type { DeactivateStaffWebAuthnKeysReq } from "./service_pb";
import type { ReactivateStaffRes } from "./service_pb";
import type { ReactivateStaffReq } from "./service_pb";
import type { DeactivateStaffRes } from "./service_pb";
import type { DeactivateStaffReq } from "./service_pb";
import type { GetActiveStaffCountRes } from "./service_pb";
import type { GetActiveStaffCountReq } from "./service_pb";
import type { ListStaffsForCompanyRes } from "./service_pb";
import type { ListStaffsForCompanyReq } from "./service_pb";
import type { UpdateStaffIsAttributionEnabledRes } from "./service_pb";
import type { UpdateStaffIsAttributionEnabledReq } from "./service_pb";
import type { UpdateStaffRes } from "./service_pb";
import type { UpdateStaffReq } from "./service_pb";
import type { CreateStaffRes } from "./service_pb";
import type { CreateStaffReq } from "./service_pb";
import type { ClearStaffAttributionPinRes } from "./service_pb";
import type { ClearStaffAttributionPinReq } from "./service_pb";
import type { ValidateStaffAttributionPinRes } from "./service_pb";
import type { ValidateStaffAttributionPinReq } from "./service_pb";
import type { GetStaffRes } from "./service_pb";
import type { GetStaffReq } from "./service_pb";
import type { CanChangeLocationRes } from "./service_pb";
import type { CanChangeLocationReq } from "./service_pb";
import type { UpdateLocationShowInventoryRes } from "./service_pb";
import type { UpdateLocationShowInventoryReq } from "./service_pb";
import type { UpdateLocationCashRoundingRes } from "./service_pb";
import type { UpdateLocationCashRoundingReq } from "./service_pb";
import type { UpdateLocationPricingRegionRes } from "./service_pb";
import type { UpdateLocationPricingRegionReq } from "./service_pb";
import type { UpdateLocationCashDrawersRes } from "./service_pb";
import type { UpdateLocationCashDrawersReq } from "./service_pb";
import type { UpdateLocationIsActiveRes } from "./service_pb";
import type { UpdateLocationIsActiveReq } from "./service_pb";
import type { UpdateLocationStatementMessageRes } from "./service_pb";
import type { UpdateLocationStatementMessageReq } from "./service_pb";
import type { UpdateLocationQuickbooksClassRes } from "./service_pb";
import type { UpdateLocationQuickbooksClassReq } from "./service_pb";
import type { UpdateLocationLogoImageUrlRes } from "./service_pb";
import type { UpdateLocationLogoImageUrlReq } from "./service_pb";
import type { UpdateLocationBMOutletNumberRes } from "./service_pb";
import type { UpdateLocationBMOutletNumberReq } from "./service_pb";
import type { UpdateLocationGoogleReviewUrlRes } from "./service_pb";
import type { UpdateLocationGoogleReviewUrlReq } from "./service_pb";
import type { ClearCardReaderRes } from "./service_pb";
import type { ClearCardReaderReq } from "./service_pb";
import type { ListCardReadersForLocationRes } from "./service_pb";
import type { ListCardReadersForLocationReq } from "./service_pb";
import type { RegisterCardReaderForLocationRes } from "./service_pb";
import type { RegisterCardReaderForLocationReq } from "./service_pb";
import type { GetActiveLocationCountRes } from "./service_pb";
import type { GetActiveLocationCountReq } from "./service_pb";
import type { ListLocationsForCompanyRes } from "./service_pb";
import type { ListLocationsForCompanyReq } from "./service_pb";
import type { UpdateLocationRes } from "./service_pb";
import type { UpdateLocationReq } from "./service_pb";
import type { CreateLocationRes } from "./service_pb";
import type { CreateLocationReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetLocationRes } from "./service_pb";
import type { GetLocationReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.company.CompanyService
 */
export interface ICompanyServiceClient {
    /**
     * Location
     *
     * @generated from protobuf rpc: GetLocation
     */
    getLocation(input: GetLocationReq, options?: RpcOptions): UnaryCall<GetLocationReq, GetLocationRes>;
    /**
     * @generated from protobuf rpc: CreateLocation
     */
    createLocation(input: CreateLocationReq, options?: RpcOptions): UnaryCall<CreateLocationReq, CreateLocationRes>;
    /**
     * @generated from protobuf rpc: UpdateLocation
     */
    updateLocation(input: UpdateLocationReq, options?: RpcOptions): UnaryCall<UpdateLocationReq, UpdateLocationRes>;
    /**
     * @generated from protobuf rpc: ListLocationsForCompany
     */
    listLocationsForCompany(input: ListLocationsForCompanyReq, options?: RpcOptions): UnaryCall<ListLocationsForCompanyReq, ListLocationsForCompanyRes>;
    /**
     * @generated from protobuf rpc: GetActiveLocationCount
     */
    getActiveLocationCount(input: GetActiveLocationCountReq, options?: RpcOptions): UnaryCall<GetActiveLocationCountReq, GetActiveLocationCountRes>;
    /**
     * @generated from protobuf rpc: RegisterCardReaderForLocation
     */
    registerCardReaderForLocation(input: RegisterCardReaderForLocationReq, options?: RpcOptions): UnaryCall<RegisterCardReaderForLocationReq, RegisterCardReaderForLocationRes>;
    /**
     * @generated from protobuf rpc: ListCardReadersForLocation
     */
    listCardReadersForLocation(input: ListCardReadersForLocationReq, options?: RpcOptions): UnaryCall<ListCardReadersForLocationReq, ListCardReadersForLocationRes>;
    /**
     * @generated from protobuf rpc: ClearCardReader
     */
    clearCardReader(input: ClearCardReaderReq, options?: RpcOptions): UnaryCall<ClearCardReaderReq, ClearCardReaderRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationGoogleReviewUrl
     */
    updateLocationGoogleReviewUrl(input: UpdateLocationGoogleReviewUrlReq, options?: RpcOptions): UnaryCall<UpdateLocationGoogleReviewUrlReq, UpdateLocationGoogleReviewUrlRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationBMOutletNumber
     */
    updateLocationBMOutletNumber(input: UpdateLocationBMOutletNumberReq, options?: RpcOptions): UnaryCall<UpdateLocationBMOutletNumberReq, UpdateLocationBMOutletNumberRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationLogoImageUrl
     */
    updateLocationLogoImageUrl(input: UpdateLocationLogoImageUrlReq, options?: RpcOptions): UnaryCall<UpdateLocationLogoImageUrlReq, UpdateLocationLogoImageUrlRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationQuickbooksClass
     */
    updateLocationQuickbooksClass(input: UpdateLocationQuickbooksClassReq, options?: RpcOptions): UnaryCall<UpdateLocationQuickbooksClassReq, UpdateLocationQuickbooksClassRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationStatementMessage
     */
    updateLocationStatementMessage(input: UpdateLocationStatementMessageReq, options?: RpcOptions): UnaryCall<UpdateLocationStatementMessageReq, UpdateLocationStatementMessageRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationIsActive
     */
    updateLocationIsActive(input: UpdateLocationIsActiveReq, options?: RpcOptions): UnaryCall<UpdateLocationIsActiveReq, UpdateLocationIsActiveRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationCashDrawers
     */
    updateLocationCashDrawers(input: UpdateLocationCashDrawersReq, options?: RpcOptions): UnaryCall<UpdateLocationCashDrawersReq, UpdateLocationCashDrawersRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationPricingRegion
     */
    updateLocationPricingRegion(input: UpdateLocationPricingRegionReq, options?: RpcOptions): UnaryCall<UpdateLocationPricingRegionReq, UpdateLocationPricingRegionRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationCashRounding
     */
    updateLocationCashRounding(input: UpdateLocationCashRoundingReq, options?: RpcOptions): UnaryCall<UpdateLocationCashRoundingReq, UpdateLocationCashRoundingRes>;
    /**
     * @generated from protobuf rpc: UpdateLocationShowInventory
     */
    updateLocationShowInventory(input: UpdateLocationShowInventoryReq, options?: RpcOptions): UnaryCall<UpdateLocationShowInventoryReq, UpdateLocationShowInventoryRes>;
    /**
     * @generated from protobuf rpc: CanChangeLocation
     */
    canChangeLocation(input: CanChangeLocationReq, options?: RpcOptions): UnaryCall<CanChangeLocationReq, CanChangeLocationRes>;
    /**
     * Staff
     *
     * @generated from protobuf rpc: GetStaff
     */
    getStaff(input: GetStaffReq, options?: RpcOptions): UnaryCall<GetStaffReq, GetStaffRes>;
    /**
     * @generated from protobuf rpc: ValidateStaffAttributionPin
     */
    validateStaffAttributionPin(input: ValidateStaffAttributionPinReq, options?: RpcOptions): UnaryCall<ValidateStaffAttributionPinReq, ValidateStaffAttributionPinRes>;
    /**
     * @generated from protobuf rpc: ClearStaffAttributionPin
     */
    clearStaffAttributionPin(input: ClearStaffAttributionPinReq, options?: RpcOptions): UnaryCall<ClearStaffAttributionPinReq, ClearStaffAttributionPinRes>;
    /**
     * @generated from protobuf rpc: CreateStaff
     */
    createStaff(input: CreateStaffReq, options?: RpcOptions): UnaryCall<CreateStaffReq, CreateStaffRes>;
    /**
     * @generated from protobuf rpc: UpdateStaff
     */
    updateStaff(input: UpdateStaffReq, options?: RpcOptions): UnaryCall<UpdateStaffReq, UpdateStaffRes>;
    /**
     * @generated from protobuf rpc: UpdateStaffIsAttributionEnabled
     */
    updateStaffIsAttributionEnabled(input: UpdateStaffIsAttributionEnabledReq, options?: RpcOptions): UnaryCall<UpdateStaffIsAttributionEnabledReq, UpdateStaffIsAttributionEnabledRes>;
    /**
     * @generated from protobuf rpc: ListStaffsForCompany
     */
    listStaffsForCompany(input: ListStaffsForCompanyReq, options?: RpcOptions): UnaryCall<ListStaffsForCompanyReq, ListStaffsForCompanyRes>;
    /**
     * @generated from protobuf rpc: GetActiveStaffCount
     */
    getActiveStaffCount(input: GetActiveStaffCountReq, options?: RpcOptions): UnaryCall<GetActiveStaffCountReq, GetActiveStaffCountRes>;
    /**
     * @generated from protobuf rpc: DeactivateStaff
     */
    deactivateStaff(input: DeactivateStaffReq, options?: RpcOptions): UnaryCall<DeactivateStaffReq, DeactivateStaffRes>;
    /**
     * @generated from protobuf rpc: ReactivateStaff
     */
    reactivateStaff(input: ReactivateStaffReq, options?: RpcOptions): UnaryCall<ReactivateStaffReq, ReactivateStaffRes>;
    /**
     * @generated from protobuf rpc: DeactivateStaffWebAuthnKeys
     */
    deactivateStaffWebAuthnKeys(input: DeactivateStaffWebAuthnKeysReq, options?: RpcOptions): UnaryCall<DeactivateStaffWebAuthnKeysReq, DeactivateStaffWebAuthnKeysRes>;
    /**
     * @generated from protobuf rpc: ListAuthorizedEndpoints
     */
    listAuthorizedEndpoints(input: ListAuthorizedEndpointsReq, options?: RpcOptions): UnaryCall<ListAuthorizedEndpointsReq, ListAuthorizedEndpointsRes>;
    /**
     * @generated from protobuf rpc: UpdateStaffPermissions
     */
    updateStaffPermissions(input: UpdateStaffPermissionsReq, options?: RpcOptions): UnaryCall<UpdateStaffPermissionsReq, UpdateStaffPermissionsRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertStaff
     */
    bulkUpsertStaff(input: BulkUpsertStaffReq, options?: RpcOptions): UnaryCall<BulkUpsertStaffReq, BulkUpsertStaffRes>;
    /**
     * Company
     *
     * @generated from protobuf rpc: GetCompanyForSubdomain
     */
    getCompanyForSubdomain(input: GetCompanyForSubdomainReq, options?: RpcOptions): UnaryCall<GetCompanyForSubdomainReq, GetCompanyForSubdomainRes>;
    /**
     * @generated from protobuf rpc: GetCompany
     */
    getCompany(input: GetCompanyReq, options?: RpcOptions): UnaryCall<GetCompanyReq, GetCompanyRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyStatementSettings
     */
    updateCompanyStatementSettings(input: UpdateCompanyStatementSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyStatementSettingsReq, UpdateCompanyStatementSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyGeneralSettings
     */
    updateCompanyGeneralSettings(input: UpdateCompanyGeneralSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyGeneralSettingsReq, UpdateCompanyGeneralSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanySecuritySettings
     */
    updateCompanySecuritySettings(input: UpdateCompanySecuritySettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanySecuritySettingsReq, UpdateCompanySecuritySettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyGeneralCommunicationsSettings
     */
    updateCompanyGeneralCommunicationsSettings(input: UpdateCompanyGeneralCommunicationsSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyGeneralCommunicationsSettingsReq, UpdateCompanyGeneralCommunicationsSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoSubmitContractorRewards
     */
    updateCompanyShouldAutoSubmitContractorRewards(input: UpdateCompanyShouldAutoSubmitContractorRewardsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoSubmitContractorRewardsReq, UpdateCompanyShouldAutoSubmitContractorRewardsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyContractorRewardsSettings
     */
    updateCompanyContractorRewardsSettings(input: UpdateCompanyContractorRewardsSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyContractorRewardsSettingsReq, UpdateCompanyContractorRewardsSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsBmDataSharingEnabled
     */
    updateCompanyIsBmDataSharingEnabled(input: UpdateCompanyIsBmDataSharingEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsBmDataSharingEnabledReq, UpdateCompanyIsBmDataSharingEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDiscountShownToCustomers
     */
    updateCompanyIsDiscountShownToCustomers(input: UpdateCompanyIsDiscountShownToCustomersReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDiscountShownToCustomersReq, UpdateCompanyIsDiscountShownToCustomersRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDiscountPercentageShownOnReceipt
     */
    updateCompanyIsDiscountPercentageShownOnReceipt(input: UpdateCompanyIsDiscountPercentageShownOnReceiptReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDiscountPercentageShownOnReceiptReq, UpdateCompanyIsDiscountPercentageShownOnReceiptRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsPriceShownOnWillCall
     */
    updateCompanyIsPriceShownOnWillCall(input: UpdateCompanyIsPriceShownOnWillCallReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsPriceShownOnWillCallReq, UpdateCompanyIsPriceShownOnWillCallRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowCostsOnTransferPrints
     */
    updateCompanyShouldShowCostsOnTransferPrints(input: UpdateCompanyShouldShowCostsOnTransferPrintsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowCostsOnTransferPrintsReq, UpdateCompanyShouldShowCostsOnTransferPrintsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsColorFormulaHidden
     */
    updateCompanyIsColorFormulaHidden(input: UpdateCompanyIsColorFormulaHiddenReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsColorFormulaHiddenReq, UpdateCompanyIsColorFormulaHiddenRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideCategoryBrowser
     */
    updateCompanyShouldHideCategoryBrowser(input: UpdateCompanyShouldHideCategoryBrowserReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideCategoryBrowserReq, UpdateCompanyShouldHideCategoryBrowserRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDesignatedClerkEnabled
     */
    updateCompanyIsDesignatedClerkEnabled(input: UpdateCompanyIsDesignatedClerkEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDesignatedClerkEnabledReq, UpdateCompanyIsDesignatedClerkEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsFinancingTermsShownOnInvoice
     */
    updateCompanyIsFinancingTermsShownOnInvoice(input: UpdateCompanyIsFinancingTermsShownOnInvoiceReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsFinancingTermsShownOnInvoiceReq, UpdateCompanyIsFinancingTermsShownOnInvoiceRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsCardSurchargeTaxExempt
     */
    updateCompanyIsCardSurchargeTaxExempt(input: UpdateCompanyIsCardSurchargeTaxExemptReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsCardSurchargeTaxExemptReq, UpdateCompanyIsCardSurchargeTaxExemptRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsLoyaltyProgramEnabled
     */
    updateCompanyIsLoyaltyProgramEnabled(input: UpdateCompanyIsLoyaltyProgramEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsLoyaltyProgramEnabledReq, UpdateCompanyIsLoyaltyProgramEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyEcommerceSettings
     */
    updateCompanyEcommerceSettings(input: UpdateCompanyEcommerceSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyEcommerceSettingsReq, UpdateCompanyEcommerceSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDepositsAndPartialFulfillmentEnabled
     */
    updateCompanyIsDepositsAndPartialFulfillmentEnabled(input: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyLoyaltyProgramPolicy
     */
    updateCompanyLoyaltyProgramPolicy(input: UpdateCompanyLoyaltyProgramPolicyReq, options?: RpcOptions): UnaryCall<UpdateCompanyLoyaltyProgramPolicyReq, UpdateCompanyLoyaltyProgramPolicyRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoSignOutAfterSaleSettings
     */
    updateCompanyShouldAutoSignOutAfterSaleSettings(input: UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsCartReaderSyncDisabled
     */
    updateCompanyIsCartReaderSyncDisabled(input: UpdateCompanyIsCartReaderSyncDisabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsCartReaderSyncDisabledReq, UpdateCompanyIsCartReaderSyncDisabledRes>;
    /**
     * Deprecated: superseded by UpdateCompanyTaxRateMode. Kept so legacy callers
     * get a clear deprecation error rather than an unknown-method failure.
     *
     * @generated from protobuf rpc: UpdateCompanyShouldPromptForAddressTaxRate
     */
    updateCompanyShouldPromptForAddressTaxRate(input: UpdateCompanyShouldPromptForAddressTaxRateReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldPromptForAddressTaxRateReq, UpdateCompanyShouldPromptForAddressTaxRateRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyTaxRateMode
     */
    updateCompanyTaxRateMode(input: UpdateCompanyTaxRateModeReq, options?: RpcOptions): UnaryCall<UpdateCompanyTaxRateModeReq, UpdateCompanyTaxRateModeRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyDefaultDepositRate
     */
    updateCompanyDefaultDepositRate(input: UpdateCompanyDefaultDepositRateReq, options?: RpcOptions): UnaryCall<UpdateCompanyDefaultDepositRateReq, UpdateCompanyDefaultDepositRateRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldSetOrderedProductQuantityToZero
     */
    updateCompanyShouldSetOrderedProductQuantityToZero(input: UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, UpdateCompanyShouldSetOrderedProductQuantityToZeroRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldTriggerOrderWhenStockBelowMin
     */
    updateCompanyShouldTriggerOrderWhenStockBelowMin(input: UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCost
     */
    updateCompanyShouldMatchStandardAndDefaultToOneTimeCost(input: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowAccountBalanceOnReceipt
     */
    updateCompanyShouldShowAccountBalanceOnReceipt(input: UpdateCompanyShouldShowAccountBalanceOnReceiptReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowAccountBalanceOnReceiptReq, UpdateCompanyShouldShowAccountBalanceOnReceiptRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowInventoryNegativeWarning
     */
    updateCompanyShouldShowInventoryNegativeWarning(input: UpdateCompanyShouldShowInventoryNegativeWarningReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowInventoryNegativeWarningReq, UpdateCompanyShouldShowInventoryNegativeWarningRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldWarnWhenSellingBelowCost
     */
    updateCompanyShouldWarnWhenSellingBelowCost(input: UpdateCompanyShouldWarnWhenSellingBelowCostReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldWarnWhenSellingBelowCostReq, UpdateCompanyShouldWarnWhenSellingBelowCostRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldSkipLinkingReturns
     */
    updateCompanyShouldSkipLinkingReturns(input: UpdateCompanyShouldSkipLinkingReturnsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldSkipLinkingReturnsReq, UpdateCompanyShouldSkipLinkingReturnsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyDefaultReceiptQuantity
     */
    updateCompanyDefaultReceiptQuantity(input: UpdateCompanyDefaultReceiptQuantityReq, options?: RpcOptions): UnaryCall<UpdateCompanyDefaultReceiptQuantityReq, UpdateCompanyDefaultReceiptQuantityRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyQuickPrintSettings
     */
    updateCompanyQuickPrintSettings(input: UpdateCompanyQuickPrintSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyQuickPrintSettingsReq, UpdateCompanyQuickPrintSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyQuickPrintPrinterByLocation
     */
    updateCompanyQuickPrintPrinterByLocation(input: UpdateCompanyQuickPrintPrinterByLocationReq, options?: RpcOptions): UnaryCall<UpdateCompanyQuickPrintPrinterByLocationReq, UpdateCompanyQuickPrintPrinterByLocationRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoApplyReturnCredits
     */
    updateCompanyShouldAutoApplyReturnCredits(input: UpdateCompanyShouldAutoApplyReturnCreditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoApplyReturnCreditsReq, UpdateCompanyShouldAutoApplyReturnCreditsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideReturnConfirmation
     */
    updateCompanyShouldHideReturnConfirmation(input: UpdateCompanyShouldHideReturnConfirmationReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideReturnConfirmationReq, UpdateCompanyShouldHideReturnConfirmationRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowReturnsWithoutNote
     */
    updateCompanyShouldAllowReturnsWithoutNote(input: UpdateCompanyShouldAllowReturnsWithoutNoteReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowReturnsWithoutNoteReq, UpdateCompanyShouldAllowReturnsWithoutNoteRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowNonStockPriceCostEdits
     */
    updateCompanyShouldAllowNonStockPriceCostEdits(input: UpdateCompanyShouldAllowNonStockPriceCostEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowNonStockPriceCostEditsReq, UpdateCompanyShouldAllowNonStockPriceCostEditsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowNonStockCostEdits
     */
    updateCompanyShouldAllowNonStockCostEdits(input: UpdateCompanyShouldAllowNonStockCostEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowNonStockCostEditsReq, UpdateCompanyShouldAllowNonStockCostEditsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireInternalSaleNotesByDefault
     */
    updateCompanyShouldRequireInternalSaleNotesByDefault(input: UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyPreserveSaleProductPriceEdits
     */
    updateCompanyPreserveSaleProductPriceEdits(input: UpdateCompanyPreserveSaleProductPriceEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyPreserveSaleProductPriceEditsReq, UpdateCompanyPreserveSaleProductPriceEditsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyAllowDifferentFulfillmentLocation
     */
    updateCompanyAllowDifferentFulfillmentLocation(input: UpdateCompanyAllowDifferentFulfillmentLocationReq, options?: RpcOptions): UnaryCall<UpdateCompanyAllowDifferentFulfillmentLocationReq, UpdateCompanyAllowDifferentFulfillmentLocationRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoApplyCreditsOnStatements
     */
    updateCompanyShouldAutoApplyCreditsOnStatements(input: UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, UpdateCompanyShouldAutoApplyCreditsOnStatementsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireVoidReason
     */
    updateCompanyShouldRequireVoidReason(input: UpdateCompanyShouldRequireVoidReasonReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireVoidReasonReq, UpdateCompanyShouldRequireVoidReasonRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDoubleSidedStatementPrintingEnabled
     */
    updateCompanyIsDoubleSidedStatementPrintingEnabled(input: UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireCustomerOnSale
     */
    updateCompanyShouldRequireCustomerOnSale(input: UpdateCompanyShouldRequireCustomerOnSaleReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireCustomerOnSaleReq, UpdateCompanyShouldRequireCustomerOnSaleRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyCustomEmailConfig
     */
    updateCompanyCustomEmailConfig(input: UpdateCompanyCustomEmailConfigReq, options?: RpcOptions): UnaryCall<UpdateCompanyCustomEmailConfigReq, UpdateCompanyCustomEmailConfigRes>;
    /**
     * @generated from protobuf rpc: ValidateCompanyCustomEmailConfig
     */
    validateCompanyCustomEmailConfig(input: ValidateCompanyCustomEmailConfigReq, options?: RpcOptions): UnaryCall<ValidateCompanyCustomEmailConfigReq, ValidateCompanyCustomEmailConfigRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyStartInventoryCountsAtOnHand
     */
    updateCompanyStartInventoryCountsAtOnHand(input: UpdateCompanyStartInventoryCountsAtOnHandReq, options?: RpcOptions): UnaryCall<UpdateCompanyStartInventoryCountsAtOnHandReq, UpdateCompanyStartInventoryCountsAtOnHandRes>;
    /**
     * @generated from protobuf rpc: GetIsBankingPermitted
     */
    getIsBankingPermitted(input: GetIsBankingPermittedReq, options?: RpcOptions): UnaryCall<GetIsBankingPermittedReq, GetIsBankingPermittedRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyIsPricingByRegionEnabled
     */
    updateCompanyIsPricingByRegionEnabled(input: UpdateCompanyIsPricingByRegionEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsPricingByRegionEnabledReq, UpdateCompanyIsPricingByRegionEnabledRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyProductImageSettings
     */
    updateCompanyProductImageSettings(input: UpdateCompanyProductImageSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyProductImageSettingsReq, UpdateCompanyProductImageSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideNetZeroActivitiesOnStatements
     */
    updateCompanyShouldHideNetZeroActivitiesOnStatements(input: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes>;
    /**
     * Tax Rates
     *
     * @generated from protobuf rpc: CreateCustomTaxRate
     */
    createCustomTaxRate(input: CreateCustomTaxRateReq, options?: RpcOptions): UnaryCall<CreateCustomTaxRateReq, CreateCustomTaxRateRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomTaxRate
     */
    updateCustomTaxRate(input: UpdateCustomTaxRateReq, options?: RpcOptions): UnaryCall<UpdateCustomTaxRateReq, UpdateCustomTaxRateRes>;
    /**
     * @generated from protobuf rpc: ReorderCustomTaxRates
     */
    reorderCustomTaxRates(input: ReorderCustomTaxRatesReq, options?: RpcOptions): UnaryCall<ReorderCustomTaxRatesReq, ReorderCustomTaxRatesRes>;
    /**
     * @generated from protobuf rpc: DeactivateCustomTaxRate
     */
    deactivateCustomTaxRate(input: DeactivateCustomTaxRateReq, options?: RpcOptions): UnaryCall<DeactivateCustomTaxRateReq, DeactivateCustomTaxRateRes>;
    /**
     * @generated from protobuf rpc: ListTaxRatesForCompany
     */
    listTaxRatesForCompany(input: ListTaxRatesForCompanyReq, options?: RpcOptions): UnaryCall<ListTaxRatesForCompanyReq, ListTaxRatesForCompanyRes>;
    /**
     * @generated from protobuf rpc: ListTaxRatesForLocation
     */
    listTaxRatesForLocation(input: ListTaxRatesForLocationReq, options?: RpcOptions): UnaryCall<ListTaxRatesForLocationReq, ListTaxRatesForLocationRes>;
    /**
     * @generated from protobuf rpc: GetOrCreateCustomTaxRateForAddress
     */
    getOrCreateCustomTaxRateForAddress(input: GetOrCreateCustomTaxRateForAddressReq, options?: RpcOptions): UnaryCall<GetOrCreateCustomTaxRateForAddressReq, GetOrCreateCustomTaxRateForAddressRes>;
    /**
     * Units of Measure
     *
     * @generated from protobuf rpc: AddCompanyUnitOfMeasure
     */
    addCompanyUnitOfMeasure(input: AddCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<AddCompanyUnitOfMeasureReq, AddCompanyUnitOfMeasureRes>;
    /**
     * @generated from protobuf rpc: UpdateCompanyUnitOfMeasure
     */
    updateCompanyUnitOfMeasure(input: UpdateCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<UpdateCompanyUnitOfMeasureReq, UpdateCompanyUnitOfMeasureRes>;
    /**
     * @generated from protobuf rpc: DeleteCompanyUnitOfMeasure
     */
    deleteCompanyUnitOfMeasure(input: DeleteCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<DeleteCompanyUnitOfMeasureReq, DeleteCompanyUnitOfMeasureRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertUnitsOfMeasure
     */
    bulkUpsertUnitsOfMeasure(input: BulkUpsertUnitsOfMeasureReq, options?: RpcOptions): UnaryCall<BulkUpsertUnitsOfMeasureReq, BulkUpsertUnitsOfMeasureRes>;
    /**
     * @generated from protobuf rpc: ListUnitsOfMeasureForCompany
     */
    listUnitsOfMeasureForCompany(input: ListUnitsOfMeasureForCompanyReq, options?: RpcOptions): UnaryCall<ListUnitsOfMeasureForCompanyReq, ListUnitsOfMeasureForCompanyRes>;
    /**
     * @generated from protobuf rpc: CanEditSaleUom
     */
    canEditSaleUom(input: CanEditSaleUomReq, options?: RpcOptions): UnaryCall<CanEditSaleUomReq, CanEditSaleUomRes>;
    /**
     * Stripe
     *
     * @generated from protobuf rpc: GetStripeOnboardingURL
     */
    getStripeOnboardingURL(input: GetStripeOnboardingURLReq, options?: RpcOptions): UnaryCall<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes>;
    /**
     * @generated from protobuf rpc: GetStripeCustomOnboardingURL
     */
    getStripeCustomOnboardingURL(input: GetStripeOnboardingURLReq, options?: RpcOptions): UnaryCall<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes>;
    /**
     * @generated from protobuf rpc: GetStripeLoginURL
     */
    getStripeLoginURL(input: GetStripeLoginURLReq, options?: RpcOptions): UnaryCall<GetStripeLoginURLReq, GetStripeLoginURLRes>;
    /**
     * @generated from protobuf rpc: GetStripeAccountSession
     */
    getStripeAccountSession(input: GetStripeAccountSessionReq, options?: RpcOptions): UnaryCall<GetStripeAccountSessionReq, GetStripeAccountSessionRes>;
    /**
     * @generated from protobuf rpc: GetIsStripePaymentsReady
     */
    getIsStripePaymentsReady(input: GetIsStripePaymentsReadyReq, options?: RpcOptions): UnaryCall<GetIsStripePaymentsReadyReq, GetIsStripePaymentsReadyRes>;
    /**
     * @generated from protobuf rpc: CreateCardSetupIntentForEntity
     */
    createCardSetupIntentForEntity(input: CreateCardSetupIntentForEntityReq, options?: RpcOptions): UnaryCall<CreateCardSetupIntentForEntityReq, CreateCardSetupIntentForEntityRes>;
    /**
     * @generated from protobuf rpc: GetEntityBillingInfo
     */
    getEntityBillingInfo(input: GetEntityBillingInfoReq, options?: RpcOptions): UnaryCall<GetEntityBillingInfoReq, GetEntityBillingInfoRes>;
    /**
     * @generated from protobuf rpc: GetNeedsBillingPaymentMethod
     */
    getNeedsBillingPaymentMethod(input: GetNeedsBillingPaymentMethodReq, options?: RpcOptions): UnaryCall<GetNeedsBillingPaymentMethodReq, GetNeedsBillingPaymentMethodRes>;
    /**
     * @generated from protobuf rpc: SetEntityDefaultPaymentMethod
     */
    setEntityDefaultPaymentMethod(input: SetEntityDefaultPaymentMethodReq, options?: RpcOptions): UnaryCall<SetEntityDefaultPaymentMethodReq, SetEntityDefaultPaymentMethodRes>;
    /**
     * Agreements
     *
     * @generated from protobuf rpc: ListAgreementsForCompany
     */
    listAgreementsForCompany(input: ListAgreementsForCompanyReq, options?: RpcOptions): UnaryCall<ListAgreementsForCompanyReq, ListAgreementsForCompanyRes>;
    /**
     * @generated from protobuf rpc: GetAgreementPDFForCompany
     */
    getAgreementPDFForCompany(input: GetAgreementPDFForCompanyReq, options?: RpcOptions): UnaryCall<GetAgreementPDFForCompanyReq, GetAgreementPDFForCompanyRes>;
    /**
     * Additional Fees
     *
     * @generated from protobuf rpc: CreateAdditionalFee
     */
    createAdditionalFee(input: CreateAdditionalFeeReq, options?: RpcOptions): UnaryCall<CreateAdditionalFeeReq, CreateAdditionalFeeRes>;
    /**
     * @generated from protobuf rpc: UpdateAdditionalFee
     */
    updateAdditionalFee(input: UpdateAdditionalFeeReq, options?: RpcOptions): UnaryCall<UpdateAdditionalFeeReq, UpdateAdditionalFeeRes>;
    /**
     * @generated from protobuf rpc: DeleteAdditionalFee
     */
    deleteAdditionalFee(input: DeleteAdditionalFeeReq, options?: RpcOptions): UnaryCall<DeleteAdditionalFeeReq, DeleteAdditionalFeeRes>;
    /**
     * @generated from protobuf rpc: ReorderAdditionalFees
     */
    reorderAdditionalFees(input: ReorderAdditionalFeesReq, options?: RpcOptions): UnaryCall<ReorderAdditionalFeesReq, ReorderAdditionalFeesRes>;
    /**
     * @generated from protobuf rpc: ListAdditionalFeesForCompany
     */
    listAdditionalFeesForCompany(input: ListAdditionalFeesForCompanyReq, options?: RpcOptions): UnaryCall<ListAdditionalFeesForCompanyReq, ListAdditionalFeesForCompanyRes>;
    /**
     * @generated from protobuf rpc: ListProductsForFee
     */
    listProductsForFee(input: ListProductsForFeeReq, options?: RpcOptions): UnaryCall<ListProductsForFeeReq, ListProductsForFeeRes>;
    /**
     * @generated from protobuf rpc: GetDefaultPaintCareFees
     */
    getDefaultPaintCareFees(input: GetDefaultPaintCareFeesReq, options?: RpcOptions): UnaryCall<GetDefaultPaintCareFeesReq, GetDefaultPaintCareFeesRes>;
    /**
     * Product Categories V2
     *
     * @generated from protobuf rpc: CreateProductCategoryV2
     */
    createProductCategoryV2(input: CreateProductCategoryV2Req, options?: RpcOptions): UnaryCall<CreateProductCategoryV2Req, CreateProductCategoryV2Res>;
    /**
     * @generated from protobuf rpc: UpdateProductCategoryV2
     */
    updateProductCategoryV2(input: UpdateProductCategoryV2Req, options?: RpcOptions): UnaryCall<UpdateProductCategoryV2Req, UpdateProductCategoryV2Res>;
    /**
     * @generated from protobuf rpc: ListProductCategoriesForCompanyV2
     */
    listProductCategoriesForCompanyV2(input: ListProductCategoriesForCompanyV2Req, options?: RpcOptions): UnaryCall<ListProductCategoriesForCompanyV2Req, ListProductCategoriesForCompanyV2Res>;
    /**
     * @generated from protobuf rpc: ListProductsForCategoryV2
     */
    listProductsForCategoryV2(input: ListProductsForCategoryV2Req, options?: RpcOptions): UnaryCall<ListProductsForCategoryV2Req, ListProductsForCategoryV2Res>;
    /**
     * @generated from protobuf rpc: GetProductCategoryTree
     */
    getProductCategoryTree(input: GetProductCategoryTreeReq, options?: RpcOptions): UnaryCall<GetProductCategoryTreeReq, GetProductCategoryTreeRes>;
    /**
     * @generated from protobuf rpc: DeactivateProductCategoryV2
     */
    deactivateProductCategoryV2(input: DeactivateProductCategoryV2Req, options?: RpcOptions): UnaryCall<DeactivateProductCategoryV2Req, DeactivateProductCategoryV2Res>;
    /**
     * @generated from protobuf rpc: BulkUpsertDepartments
     */
    bulkUpsertDepartments(input: BulkUpsertDepartmentsReq, options?: RpcOptions): UnaryCall<BulkUpsertDepartmentsReq, BulkUpsertDepartmentsRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertClasses
     */
    bulkUpsertClasses(input: BulkUpsertClassesReq, options?: RpcOptions): UnaryCall<BulkUpsertClassesReq, BulkUpsertClassesRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertFinelines
     */
    bulkUpsertFinelines(input: BulkUpsertFinelineReq, options?: RpcOptions): UnaryCall<BulkUpsertFinelineReq, BulkUpsertFinelineRes>;
    /**
     * FinancingTerms
     *
     * @generated from protobuf rpc: CreateFinancingTerm
     */
    createFinancingTerm(input: CreateFinancingTermReq, options?: RpcOptions): UnaryCall<CreateFinancingTermReq, CreateFinancingTermRes>;
    /**
     * @generated from protobuf rpc: UpdateFinancingTerm
     */
    updateFinancingTerm(input: UpdateFinancingTermReq, options?: RpcOptions): UnaryCall<UpdateFinancingTermReq, UpdateFinancingTermRes>;
    /**
     * @generated from protobuf rpc: DeleteFinancingTerm
     */
    deleteFinancingTerm(input: DeleteFinancingTermReq, options?: RpcOptions): UnaryCall<DeleteFinancingTermReq, DeleteFinancingTermRes>;
    /**
     * @generated from protobuf rpc: ReorderFinancingTerms
     */
    reorderFinancingTerms(input: ReorderFinancingTermsReq, options?: RpcOptions): UnaryCall<ReorderFinancingTermsReq, ReorderFinancingTermsRes>;
    /**
     * @generated from protobuf rpc: ListFinancingTermsForCompany
     */
    listFinancingTermsForCompany(input: ListFinancingTermsForCompanyReq, options?: RpcOptions): UnaryCall<ListFinancingTermsForCompanyReq, ListFinancingTermsForCompanyRes>;
    /**
     * @generated from protobuf rpc: ListCustomersForTerm
     */
    listCustomersForTerm(input: ListCustomersForTermReq, options?: RpcOptions): UnaryCall<ListCustomersForTermReq, ListCustomersForTermRes>;
    /**
     * Pricing Tiers
     *
     * @generated from protobuf rpc: CreatePricingTier
     */
    createPricingTier(input: CreatePricingTierReq, options?: RpcOptions): UnaryCall<CreatePricingTierReq, CreatePricingTierRes>;
    /**
     * @generated from protobuf rpc: UpdatePricingTier
     */
    updatePricingTier(input: UpdatePricingTierReq, options?: RpcOptions): UnaryCall<UpdatePricingTierReq, UpdatePricingTierRes>;
    /**
     * @generated from protobuf rpc: DeletePricingTier
     */
    deletePricingTier(input: DeletePricingTierReq, options?: RpcOptions): UnaryCall<DeletePricingTierReq, DeletePricingTierRes>;
    /**
     * @generated from protobuf rpc: ReorderPricingTiers
     */
    reorderPricingTiers(input: ReorderPricingTiersReq, options?: RpcOptions): UnaryCall<ReorderPricingTiersReq, ReorderPricingTiersRes>;
    /**
     * @generated from protobuf rpc: ListPricingTiersForCompany
     */
    listPricingTiersForCompany(input: ListPricingTiersForCompanyReq, options?: RpcOptions): UnaryCall<ListPricingTiersForCompanyReq, ListPricingTiersForCompanyRes>;
    /**
     * @generated from protobuf rpc: ListCustomersForTier
     */
    listCustomersForTier(input: ListCustomersForTierReq, options?: RpcOptions): UnaryCall<ListCustomersForTierReq, ListCustomersForTierRes>;
    /**
     * User
     *
     * @generated from protobuf rpc: GetCurrentUser
     */
    getCurrentUser(input: GetCurrentUserReq, options?: RpcOptions): UnaryCall<GetCurrentUserReq, GetCurrentUserRes>;
    /**
     * @generated from protobuf rpc: GetCurrentUserIsAttributionEnabled
     */
    getCurrentUserIsAttributionEnabled(input: GetCurrentUserIsAttributionEnabledReq, options?: RpcOptions): UnaryCall<GetCurrentUserIsAttributionEnabledReq, GetCurrentUserIsAttributionEnabledRes>;
    /**
     * Credit Card
     *
     * @generated from protobuf rpc: UpdateCardSurchargeRate
     */
    updateCardSurchargeRate(input: UpdateCardSurchargeRateReq, options?: RpcOptions): UnaryCall<UpdateCardSurchargeRateReq, UpdateCardSurchargeRateRes>;
    /**
     * Roles
     *
     * @generated from protobuf rpc: GetPermissionsGroups
     */
    getPermissionsGroups(input: GetPermissionsGroupsReq, options?: RpcOptions): UnaryCall<GetPermissionsGroupsReq, GetPermissionsGroupsRes>;
    /**
     * Finance Charge Settings
     *
     * @generated from protobuf rpc: CreateFinanceChargeSetting
     */
    createFinanceChargeSetting(input: CreateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<CreateFinanceChargeSettingReq, CreateFinanceChargeSettingRes>;
    /**
     * @generated from protobuf rpc: UpdateFinanceChargeSetting
     */
    updateFinanceChargeSetting(input: UpdateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<UpdateFinanceChargeSettingReq, UpdateFinanceChargeSettingRes>;
    /**
     * @generated from protobuf rpc: ListActiveFinanceChargeSettingsForCompany
     */
    listActiveFinanceChargeSettingsForCompany(input: ListActiveFinanceChargeSettingsForCompanyReq, options?: RpcOptions): UnaryCall<ListActiveFinanceChargeSettingsForCompanyReq, ListActiveFinanceChargeSettingsForCompanyRes>;
    /**
     * @generated from protobuf rpc: ListCustomersForFinanceChargeSetting
     */
    listCustomersForFinanceChargeSetting(input: ListCustomersForFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<ListCustomersForFinanceChargeSettingReq, ListCustomersForFinanceChargeSettingRes>;
    /**
     * @generated from protobuf rpc: DeactivateFinanceChargeSetting
     */
    deactivateFinanceChargeSetting(input: DeactivateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<DeactivateFinanceChargeSettingReq, DeactivateFinanceChargeSettingRes>;
    /**
     * @generated from protobuf rpc: ReorderFinanceChargeSettings
     */
    reorderFinanceChargeSettings(input: ReorderFinanceChargeSettingsReq, options?: RpcOptions): UnaryCall<ReorderFinanceChargeSettingsReq, ReorderFinanceChargeSettingsRes>;
    /**
     * Cost Management
     *
     * @generated from protobuf rpc: UpdateCostManagementSettings
     */
    updateCostManagementSettings(input: UpdateCostManagementSettingsReq, options?: RpcOptions): UnaryCall<UpdateCostManagementSettingsReq, UpdateCostManagementSettingsRes>;
    /**
     * Sale Forms
     *
     * @generated from protobuf rpc: CreateSaleForm
     */
    createSaleForm(input: CreateSaleFormReq, options?: RpcOptions): UnaryCall<CreateSaleFormReq, CreateSaleFormRes>;
    /**
     * @generated from protobuf rpc: UpdateSaleForm
     */
    updateSaleForm(input: UpdateSaleFormReq, options?: RpcOptions): UnaryCall<UpdateSaleFormReq, UpdateSaleFormRes>;
    /**
     * @generated from protobuf rpc: ListSaleForms
     */
    listSaleForms(input: ListSaleFormsReq, options?: RpcOptions): UnaryCall<ListSaleFormsReq, ListSaleFormsRes>;
    /**
     * @generated from protobuf rpc: DeleteSaleForm
     */
    deleteSaleForm(input: DeleteSaleFormReq, options?: RpcOptions): UnaryCall<DeleteSaleFormReq, DeleteSaleFormRes>;
    /**
     * Entities
     *
     * @generated from protobuf rpc: ListEntitiesForCompany
     */
    listEntitiesForCompany(input: ListEntitiesForCompanyReq, options?: RpcOptions): UnaryCall<ListEntitiesForCompanyReq, ListEntitiesForCompanyRes>;
    /**
     * Methods
     *
     * @generated from protobuf rpc: ListDrawerMethods
     */
    listDrawerMethods(input: ListDrawerMethodsReq, options?: RpcOptions): UnaryCall<ListDrawerMethodsReq, ListDrawerMethodsRes>;
    /**
     * @generated from protobuf rpc: CreateCustomTenderMethod
     */
    createCustomTenderMethod(input: CreateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<CreateCustomTenderMethodReq, CreateCustomTenderMethodRes>;
    /**
     * @generated from protobuf rpc: UpdateCustomTenderMethod
     */
    updateCustomTenderMethod(input: UpdateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<UpdateCustomTenderMethodReq, UpdateCustomTenderMethodRes>;
    /**
     * @generated from protobuf rpc: UpdateDefaultTenderMethodUsages
     */
    updateDefaultTenderMethodUsages(input: UpdateDefaultTenderMethodUsagesReq, options?: RpcOptions): UnaryCall<UpdateDefaultTenderMethodUsagesReq, UpdateDefaultTenderMethodUsagesRes>;
    /**
     * @generated from protobuf rpc: DeactivateCustomTenderMethod
     */
    deactivateCustomTenderMethod(input: DeactivateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<DeactivateCustomTenderMethodReq, DeactivateCustomTenderMethodRes>;
    /**
     * @generated from protobuf rpc: ActivateCustomTenderMethod
     */
    activateCustomTenderMethod(input: ActivateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<ActivateCustomTenderMethodReq, ActivateCustomTenderMethodRes>;
    /**
     * @generated from protobuf rpc: ReorderTenderMethods
     */
    reorderTenderMethods(input: ReorderTenderMethodsReq, options?: RpcOptions): UnaryCall<ReorderTenderMethodsReq, ReorderTenderMethodsRes>;
    /**
     * @generated from protobuf rpc: GetActiveTenderMethodCount
     */
    getActiveTenderMethodCount(input: GetActiveTenderMethodCountReq, options?: RpcOptions): UnaryCall<GetActiveTenderMethodCountReq, GetActiveTenderMethodCountRes>;
    /**
     * @generated from protobuf rpc: GetIsGiftCardsEnabled
     */
    getIsGiftCardsEnabled(input: GetIsGiftCardsEnabledReq, options?: RpcOptions): UnaryCall<GetIsGiftCardsEnabledReq, GetIsGiftCardsEnabledRes>;
    /**
     * Pricing Regions
     *
     * @generated from protobuf rpc: CreatePricingRegion
     */
    createPricingRegion(input: CreatePricingRegionReq, options?: RpcOptions): UnaryCall<CreatePricingRegionReq, CreatePricingRegionRes>;
    /**
     * @generated from protobuf rpc: UpdatePricingRegionName
     */
    updatePricingRegionName(input: UpdatePricingRegionNameReq, options?: RpcOptions): UnaryCall<UpdatePricingRegionNameReq, UpdatePricingRegionNameRes>;
    /**
     * @generated from protobuf rpc: UpdateDefaultPricingRegion
     */
    updateDefaultPricingRegion(input: UpdateDefaultPricingRegionReq, options?: RpcOptions): UnaryCall<UpdateDefaultPricingRegionReq, UpdateDefaultPricingRegionRes>;
    /**
     * @generated from protobuf rpc: DeactivatePricingRegion
     */
    deactivatePricingRegion(input: DeactivatePricingRegionReq, options?: RpcOptions): UnaryCall<DeactivatePricingRegionReq, DeactivatePricingRegionRes>;
    /**
     * @generated from protobuf rpc: ReorderPricingRegions
     */
    reorderPricingRegions(input: ReorderPricingRegionsReq, options?: RpcOptions): UnaryCall<ReorderPricingRegionsReq, ReorderPricingRegionsRes>;
    /**
     * @generated from protobuf rpc: ListPricingRegionsForCompany
     */
    listPricingRegionsForCompany(input: ListPricingRegionsForCompanyReq, options?: RpcOptions): UnaryCall<ListPricingRegionsForCompanyReq, ListPricingRegionsForCompanyRes>;
}
/**
 * @generated from protobuf service rd.api.company.CompanyService
 */
export class CompanyServiceClient implements ICompanyServiceClient, ServiceInfo {
    typeName = CompanyService.typeName;
    methods = CompanyService.methods;
    options = CompanyService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Location
     *
     * @generated from protobuf rpc: GetLocation
     */
    getLocation(input: GetLocationReq, options?: RpcOptions): UnaryCall<GetLocationReq, GetLocationRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLocationReq, GetLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateLocation
     */
    createLocation(input: CreateLocationReq, options?: RpcOptions): UnaryCall<CreateLocationReq, CreateLocationRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateLocationReq, CreateLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocation
     */
    updateLocation(input: UpdateLocationReq, options?: RpcOptions): UnaryCall<UpdateLocationReq, UpdateLocationRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationReq, UpdateLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListLocationsForCompany
     */
    listLocationsForCompany(input: ListLocationsForCompanyReq, options?: RpcOptions): UnaryCall<ListLocationsForCompanyReq, ListLocationsForCompanyRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListLocationsForCompanyReq, ListLocationsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetActiveLocationCount
     */
    getActiveLocationCount(input: GetActiveLocationCountReq, options?: RpcOptions): UnaryCall<GetActiveLocationCountReq, GetActiveLocationCountRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveLocationCountReq, GetActiveLocationCountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RegisterCardReaderForLocation
     */
    registerCardReaderForLocation(input: RegisterCardReaderForLocationReq, options?: RpcOptions): UnaryCall<RegisterCardReaderForLocationReq, RegisterCardReaderForLocationRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<RegisterCardReaderForLocationReq, RegisterCardReaderForLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCardReadersForLocation
     */
    listCardReadersForLocation(input: ListCardReadersForLocationReq, options?: RpcOptions): UnaryCall<ListCardReadersForLocationReq, ListCardReadersForLocationRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCardReadersForLocationReq, ListCardReadersForLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ClearCardReader
     */
    clearCardReader(input: ClearCardReaderReq, options?: RpcOptions): UnaryCall<ClearCardReaderReq, ClearCardReaderRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ClearCardReaderReq, ClearCardReaderRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationGoogleReviewUrl
     */
    updateLocationGoogleReviewUrl(input: UpdateLocationGoogleReviewUrlReq, options?: RpcOptions): UnaryCall<UpdateLocationGoogleReviewUrlReq, UpdateLocationGoogleReviewUrlRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationGoogleReviewUrlReq, UpdateLocationGoogleReviewUrlRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationBMOutletNumber
     */
    updateLocationBMOutletNumber(input: UpdateLocationBMOutletNumberReq, options?: RpcOptions): UnaryCall<UpdateLocationBMOutletNumberReq, UpdateLocationBMOutletNumberRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationBMOutletNumberReq, UpdateLocationBMOutletNumberRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationLogoImageUrl
     */
    updateLocationLogoImageUrl(input: UpdateLocationLogoImageUrlReq, options?: RpcOptions): UnaryCall<UpdateLocationLogoImageUrlReq, UpdateLocationLogoImageUrlRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationLogoImageUrlReq, UpdateLocationLogoImageUrlRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationQuickbooksClass
     */
    updateLocationQuickbooksClass(input: UpdateLocationQuickbooksClassReq, options?: RpcOptions): UnaryCall<UpdateLocationQuickbooksClassReq, UpdateLocationQuickbooksClassRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationQuickbooksClassReq, UpdateLocationQuickbooksClassRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationStatementMessage
     */
    updateLocationStatementMessage(input: UpdateLocationStatementMessageReq, options?: RpcOptions): UnaryCall<UpdateLocationStatementMessageReq, UpdateLocationStatementMessageRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationStatementMessageReq, UpdateLocationStatementMessageRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationIsActive
     */
    updateLocationIsActive(input: UpdateLocationIsActiveReq, options?: RpcOptions): UnaryCall<UpdateLocationIsActiveReq, UpdateLocationIsActiveRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationIsActiveReq, UpdateLocationIsActiveRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationCashDrawers
     */
    updateLocationCashDrawers(input: UpdateLocationCashDrawersReq, options?: RpcOptions): UnaryCall<UpdateLocationCashDrawersReq, UpdateLocationCashDrawersRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationCashDrawersReq, UpdateLocationCashDrawersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationPricingRegion
     */
    updateLocationPricingRegion(input: UpdateLocationPricingRegionReq, options?: RpcOptions): UnaryCall<UpdateLocationPricingRegionReq, UpdateLocationPricingRegionRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationPricingRegionReq, UpdateLocationPricingRegionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationCashRounding
     */
    updateLocationCashRounding(input: UpdateLocationCashRoundingReq, options?: RpcOptions): UnaryCall<UpdateLocationCashRoundingReq, UpdateLocationCashRoundingRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationCashRoundingReq, UpdateLocationCashRoundingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateLocationShowInventory
     */
    updateLocationShowInventory(input: UpdateLocationShowInventoryReq, options?: RpcOptions): UnaryCall<UpdateLocationShowInventoryReq, UpdateLocationShowInventoryRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationShowInventoryReq, UpdateLocationShowInventoryRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CanChangeLocation
     */
    canChangeLocation(input: CanChangeLocationReq, options?: RpcOptions): UnaryCall<CanChangeLocationReq, CanChangeLocationRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<CanChangeLocationReq, CanChangeLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Staff
     *
     * @generated from protobuf rpc: GetStaff
     */
    getStaff(input: GetStaffReq, options?: RpcOptions): UnaryCall<GetStaffReq, GetStaffRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStaffReq, GetStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ValidateStaffAttributionPin
     */
    validateStaffAttributionPin(input: ValidateStaffAttributionPinReq, options?: RpcOptions): UnaryCall<ValidateStaffAttributionPinReq, ValidateStaffAttributionPinRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<ValidateStaffAttributionPinReq, ValidateStaffAttributionPinRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ClearStaffAttributionPin
     */
    clearStaffAttributionPin(input: ClearStaffAttributionPinReq, options?: RpcOptions): UnaryCall<ClearStaffAttributionPinReq, ClearStaffAttributionPinRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<ClearStaffAttributionPinReq, ClearStaffAttributionPinRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateStaff
     */
    createStaff(input: CreateStaffReq, options?: RpcOptions): UnaryCall<CreateStaffReq, CreateStaffRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateStaffReq, CreateStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateStaff
     */
    updateStaff(input: UpdateStaffReq, options?: RpcOptions): UnaryCall<UpdateStaffReq, UpdateStaffRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStaffReq, UpdateStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateStaffIsAttributionEnabled
     */
    updateStaffIsAttributionEnabled(input: UpdateStaffIsAttributionEnabledReq, options?: RpcOptions): UnaryCall<UpdateStaffIsAttributionEnabledReq, UpdateStaffIsAttributionEnabledRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStaffIsAttributionEnabledReq, UpdateStaffIsAttributionEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListStaffsForCompany
     */
    listStaffsForCompany(input: ListStaffsForCompanyReq, options?: RpcOptions): UnaryCall<ListStaffsForCompanyReq, ListStaffsForCompanyRes> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListStaffsForCompanyReq, ListStaffsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetActiveStaffCount
     */
    getActiveStaffCount(input: GetActiveStaffCountReq, options?: RpcOptions): UnaryCall<GetActiveStaffCountReq, GetActiveStaffCountRes> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveStaffCountReq, GetActiveStaffCountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateStaff
     */
    deactivateStaff(input: DeactivateStaffReq, options?: RpcOptions): UnaryCall<DeactivateStaffReq, DeactivateStaffRes> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateStaffReq, DeactivateStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReactivateStaff
     */
    reactivateStaff(input: ReactivateStaffReq, options?: RpcOptions): UnaryCall<ReactivateStaffReq, ReactivateStaffRes> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReactivateStaffReq, ReactivateStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateStaffWebAuthnKeys
     */
    deactivateStaffWebAuthnKeys(input: DeactivateStaffWebAuthnKeysReq, options?: RpcOptions): UnaryCall<DeactivateStaffWebAuthnKeysReq, DeactivateStaffWebAuthnKeysRes> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateStaffWebAuthnKeysReq, DeactivateStaffWebAuthnKeysRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAuthorizedEndpoints
     */
    listAuthorizedEndpoints(input: ListAuthorizedEndpointsReq, options?: RpcOptions): UnaryCall<ListAuthorizedEndpointsReq, ListAuthorizedEndpointsRes> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAuthorizedEndpointsReq, ListAuthorizedEndpointsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateStaffPermissions
     */
    updateStaffPermissions(input: UpdateStaffPermissionsReq, options?: RpcOptions): UnaryCall<UpdateStaffPermissionsReq, UpdateStaffPermissionsRes> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStaffPermissionsReq, UpdateStaffPermissionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertStaff
     */
    bulkUpsertStaff(input: BulkUpsertStaffReq, options?: RpcOptions): UnaryCall<BulkUpsertStaffReq, BulkUpsertStaffRes> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertStaffReq, BulkUpsertStaffRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Company
     *
     * @generated from protobuf rpc: GetCompanyForSubdomain
     */
    getCompanyForSubdomain(input: GetCompanyForSubdomainReq, options?: RpcOptions): UnaryCall<GetCompanyForSubdomainReq, GetCompanyForSubdomainRes> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCompanyForSubdomainReq, GetCompanyForSubdomainRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCompany
     */
    getCompany(input: GetCompanyReq, options?: RpcOptions): UnaryCall<GetCompanyReq, GetCompanyRes> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCompanyReq, GetCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyStatementSettings
     */
    updateCompanyStatementSettings(input: UpdateCompanyStatementSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyStatementSettingsReq, UpdateCompanyStatementSettingsRes> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyStatementSettingsReq, UpdateCompanyStatementSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyGeneralSettings
     */
    updateCompanyGeneralSettings(input: UpdateCompanyGeneralSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyGeneralSettingsReq, UpdateCompanyGeneralSettingsRes> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyGeneralSettingsReq, UpdateCompanyGeneralSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanySecuritySettings
     */
    updateCompanySecuritySettings(input: UpdateCompanySecuritySettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanySecuritySettingsReq, UpdateCompanySecuritySettingsRes> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanySecuritySettingsReq, UpdateCompanySecuritySettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyGeneralCommunicationsSettings
     */
    updateCompanyGeneralCommunicationsSettings(input: UpdateCompanyGeneralCommunicationsSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyGeneralCommunicationsSettingsReq, UpdateCompanyGeneralCommunicationsSettingsRes> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyGeneralCommunicationsSettingsReq, UpdateCompanyGeneralCommunicationsSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoSubmitContractorRewards
     */
    updateCompanyShouldAutoSubmitContractorRewards(input: UpdateCompanyShouldAutoSubmitContractorRewardsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoSubmitContractorRewardsReq, UpdateCompanyShouldAutoSubmitContractorRewardsRes> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAutoSubmitContractorRewardsReq, UpdateCompanyShouldAutoSubmitContractorRewardsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyContractorRewardsSettings
     */
    updateCompanyContractorRewardsSettings(input: UpdateCompanyContractorRewardsSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyContractorRewardsSettingsReq, UpdateCompanyContractorRewardsSettingsRes> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyContractorRewardsSettingsReq, UpdateCompanyContractorRewardsSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsBmDataSharingEnabled
     */
    updateCompanyIsBmDataSharingEnabled(input: UpdateCompanyIsBmDataSharingEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsBmDataSharingEnabledReq, UpdateCompanyIsBmDataSharingEnabledRes> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsBmDataSharingEnabledReq, UpdateCompanyIsBmDataSharingEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDiscountShownToCustomers
     */
    updateCompanyIsDiscountShownToCustomers(input: UpdateCompanyIsDiscountShownToCustomersReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDiscountShownToCustomersReq, UpdateCompanyIsDiscountShownToCustomersRes> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsDiscountShownToCustomersReq, UpdateCompanyIsDiscountShownToCustomersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDiscountPercentageShownOnReceipt
     */
    updateCompanyIsDiscountPercentageShownOnReceipt(input: UpdateCompanyIsDiscountPercentageShownOnReceiptReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDiscountPercentageShownOnReceiptReq, UpdateCompanyIsDiscountPercentageShownOnReceiptRes> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsDiscountPercentageShownOnReceiptReq, UpdateCompanyIsDiscountPercentageShownOnReceiptRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsPriceShownOnWillCall
     */
    updateCompanyIsPriceShownOnWillCall(input: UpdateCompanyIsPriceShownOnWillCallReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsPriceShownOnWillCallReq, UpdateCompanyIsPriceShownOnWillCallRes> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsPriceShownOnWillCallReq, UpdateCompanyIsPriceShownOnWillCallRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowCostsOnTransferPrints
     */
    updateCompanyShouldShowCostsOnTransferPrints(input: UpdateCompanyShouldShowCostsOnTransferPrintsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowCostsOnTransferPrintsReq, UpdateCompanyShouldShowCostsOnTransferPrintsRes> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldShowCostsOnTransferPrintsReq, UpdateCompanyShouldShowCostsOnTransferPrintsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsColorFormulaHidden
     */
    updateCompanyIsColorFormulaHidden(input: UpdateCompanyIsColorFormulaHiddenReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsColorFormulaHiddenReq, UpdateCompanyIsColorFormulaHiddenRes> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsColorFormulaHiddenReq, UpdateCompanyIsColorFormulaHiddenRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideCategoryBrowser
     */
    updateCompanyShouldHideCategoryBrowser(input: UpdateCompanyShouldHideCategoryBrowserReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideCategoryBrowserReq, UpdateCompanyShouldHideCategoryBrowserRes> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldHideCategoryBrowserReq, UpdateCompanyShouldHideCategoryBrowserRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDesignatedClerkEnabled
     */
    updateCompanyIsDesignatedClerkEnabled(input: UpdateCompanyIsDesignatedClerkEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDesignatedClerkEnabledReq, UpdateCompanyIsDesignatedClerkEnabledRes> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsDesignatedClerkEnabledReq, UpdateCompanyIsDesignatedClerkEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsFinancingTermsShownOnInvoice
     */
    updateCompanyIsFinancingTermsShownOnInvoice(input: UpdateCompanyIsFinancingTermsShownOnInvoiceReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsFinancingTermsShownOnInvoiceReq, UpdateCompanyIsFinancingTermsShownOnInvoiceRes> {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsFinancingTermsShownOnInvoiceReq, UpdateCompanyIsFinancingTermsShownOnInvoiceRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsCardSurchargeTaxExempt
     */
    updateCompanyIsCardSurchargeTaxExempt(input: UpdateCompanyIsCardSurchargeTaxExemptReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsCardSurchargeTaxExemptReq, UpdateCompanyIsCardSurchargeTaxExemptRes> {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsCardSurchargeTaxExemptReq, UpdateCompanyIsCardSurchargeTaxExemptRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsLoyaltyProgramEnabled
     */
    updateCompanyIsLoyaltyProgramEnabled(input: UpdateCompanyIsLoyaltyProgramEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsLoyaltyProgramEnabledReq, UpdateCompanyIsLoyaltyProgramEnabledRes> {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsLoyaltyProgramEnabledReq, UpdateCompanyIsLoyaltyProgramEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyEcommerceSettings
     */
    updateCompanyEcommerceSettings(input: UpdateCompanyEcommerceSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyEcommerceSettingsReq, UpdateCompanyEcommerceSettingsRes> {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyEcommerceSettingsReq, UpdateCompanyEcommerceSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDepositsAndPartialFulfillmentEnabled
     */
    updateCompanyIsDepositsAndPartialFulfillmentEnabled(input: UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes> {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsDepositsAndPartialFulfillmentEnabledReq, UpdateCompanyIsDepositsAndPartialFulfillmentEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyLoyaltyProgramPolicy
     */
    updateCompanyLoyaltyProgramPolicy(input: UpdateCompanyLoyaltyProgramPolicyReq, options?: RpcOptions): UnaryCall<UpdateCompanyLoyaltyProgramPolicyReq, UpdateCompanyLoyaltyProgramPolicyRes> {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyLoyaltyProgramPolicyReq, UpdateCompanyLoyaltyProgramPolicyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoSignOutAfterSaleSettings
     */
    updateCompanyShouldAutoSignOutAfterSaleSettings(input: UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes> {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAutoSignOutAfterSaleSettingsReq, UpdateCompanyShouldAutoSignOutAfterSaleSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsCartReaderSyncDisabled
     */
    updateCompanyIsCartReaderSyncDisabled(input: UpdateCompanyIsCartReaderSyncDisabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsCartReaderSyncDisabledReq, UpdateCompanyIsCartReaderSyncDisabledRes> {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsCartReaderSyncDisabledReq, UpdateCompanyIsCartReaderSyncDisabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Deprecated: superseded by UpdateCompanyTaxRateMode. Kept so legacy callers
     * get a clear deprecation error rather than an unknown-method failure.
     *
     * @generated from protobuf rpc: UpdateCompanyShouldPromptForAddressTaxRate
     */
    updateCompanyShouldPromptForAddressTaxRate(input: UpdateCompanyShouldPromptForAddressTaxRateReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldPromptForAddressTaxRateReq, UpdateCompanyShouldPromptForAddressTaxRateRes> {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldPromptForAddressTaxRateReq, UpdateCompanyShouldPromptForAddressTaxRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyTaxRateMode
     */
    updateCompanyTaxRateMode(input: UpdateCompanyTaxRateModeReq, options?: RpcOptions): UnaryCall<UpdateCompanyTaxRateModeReq, UpdateCompanyTaxRateModeRes> {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyTaxRateModeReq, UpdateCompanyTaxRateModeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyDefaultDepositRate
     */
    updateCompanyDefaultDepositRate(input: UpdateCompanyDefaultDepositRateReq, options?: RpcOptions): UnaryCall<UpdateCompanyDefaultDepositRateReq, UpdateCompanyDefaultDepositRateRes> {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyDefaultDepositRateReq, UpdateCompanyDefaultDepositRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldSetOrderedProductQuantityToZero
     */
    updateCompanyShouldSetOrderedProductQuantityToZero(input: UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, UpdateCompanyShouldSetOrderedProductQuantityToZeroRes> {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldSetOrderedProductQuantityToZeroReq, UpdateCompanyShouldSetOrderedProductQuantityToZeroRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldTriggerOrderWhenStockBelowMin
     */
    updateCompanyShouldTriggerOrderWhenStockBelowMin(input: UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes> {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldTriggerOrderWhenStockBelowMinReq, UpdateCompanyShouldTriggerOrderWhenStockBelowMinRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCost
     */
    updateCompanyShouldMatchStandardAndDefaultToOneTimeCost(input: UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes> {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostReq, UpdateCompanyShouldMatchStandardAndDefaultToOneTimeCostRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowAccountBalanceOnReceipt
     */
    updateCompanyShouldShowAccountBalanceOnReceipt(input: UpdateCompanyShouldShowAccountBalanceOnReceiptReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowAccountBalanceOnReceiptReq, UpdateCompanyShouldShowAccountBalanceOnReceiptRes> {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldShowAccountBalanceOnReceiptReq, UpdateCompanyShouldShowAccountBalanceOnReceiptRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldShowInventoryNegativeWarning
     */
    updateCompanyShouldShowInventoryNegativeWarning(input: UpdateCompanyShouldShowInventoryNegativeWarningReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldShowInventoryNegativeWarningReq, UpdateCompanyShouldShowInventoryNegativeWarningRes> {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldShowInventoryNegativeWarningReq, UpdateCompanyShouldShowInventoryNegativeWarningRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldWarnWhenSellingBelowCost
     */
    updateCompanyShouldWarnWhenSellingBelowCost(input: UpdateCompanyShouldWarnWhenSellingBelowCostReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldWarnWhenSellingBelowCostReq, UpdateCompanyShouldWarnWhenSellingBelowCostRes> {
        const method = this.methods[65], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldWarnWhenSellingBelowCostReq, UpdateCompanyShouldWarnWhenSellingBelowCostRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldSkipLinkingReturns
     */
    updateCompanyShouldSkipLinkingReturns(input: UpdateCompanyShouldSkipLinkingReturnsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldSkipLinkingReturnsReq, UpdateCompanyShouldSkipLinkingReturnsRes> {
        const method = this.methods[66], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldSkipLinkingReturnsReq, UpdateCompanyShouldSkipLinkingReturnsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyDefaultReceiptQuantity
     */
    updateCompanyDefaultReceiptQuantity(input: UpdateCompanyDefaultReceiptQuantityReq, options?: RpcOptions): UnaryCall<UpdateCompanyDefaultReceiptQuantityReq, UpdateCompanyDefaultReceiptQuantityRes> {
        const method = this.methods[67], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyDefaultReceiptQuantityReq, UpdateCompanyDefaultReceiptQuantityRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyQuickPrintSettings
     */
    updateCompanyQuickPrintSettings(input: UpdateCompanyQuickPrintSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyQuickPrintSettingsReq, UpdateCompanyQuickPrintSettingsRes> {
        const method = this.methods[68], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyQuickPrintSettingsReq, UpdateCompanyQuickPrintSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyQuickPrintPrinterByLocation
     */
    updateCompanyQuickPrintPrinterByLocation(input: UpdateCompanyQuickPrintPrinterByLocationReq, options?: RpcOptions): UnaryCall<UpdateCompanyQuickPrintPrinterByLocationReq, UpdateCompanyQuickPrintPrinterByLocationRes> {
        const method = this.methods[69], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyQuickPrintPrinterByLocationReq, UpdateCompanyQuickPrintPrinterByLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoApplyReturnCredits
     */
    updateCompanyShouldAutoApplyReturnCredits(input: UpdateCompanyShouldAutoApplyReturnCreditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoApplyReturnCreditsReq, UpdateCompanyShouldAutoApplyReturnCreditsRes> {
        const method = this.methods[70], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAutoApplyReturnCreditsReq, UpdateCompanyShouldAutoApplyReturnCreditsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideReturnConfirmation
     */
    updateCompanyShouldHideReturnConfirmation(input: UpdateCompanyShouldHideReturnConfirmationReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideReturnConfirmationReq, UpdateCompanyShouldHideReturnConfirmationRes> {
        const method = this.methods[71], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldHideReturnConfirmationReq, UpdateCompanyShouldHideReturnConfirmationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowReturnsWithoutNote
     */
    updateCompanyShouldAllowReturnsWithoutNote(input: UpdateCompanyShouldAllowReturnsWithoutNoteReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowReturnsWithoutNoteReq, UpdateCompanyShouldAllowReturnsWithoutNoteRes> {
        const method = this.methods[72], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAllowReturnsWithoutNoteReq, UpdateCompanyShouldAllowReturnsWithoutNoteRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowNonStockPriceCostEdits
     */
    updateCompanyShouldAllowNonStockPriceCostEdits(input: UpdateCompanyShouldAllowNonStockPriceCostEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowNonStockPriceCostEditsReq, UpdateCompanyShouldAllowNonStockPriceCostEditsRes> {
        const method = this.methods[73], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAllowNonStockPriceCostEditsReq, UpdateCompanyShouldAllowNonStockPriceCostEditsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAllowNonStockCostEdits
     */
    updateCompanyShouldAllowNonStockCostEdits(input: UpdateCompanyShouldAllowNonStockCostEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAllowNonStockCostEditsReq, UpdateCompanyShouldAllowNonStockCostEditsRes> {
        const method = this.methods[74], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAllowNonStockCostEditsReq, UpdateCompanyShouldAllowNonStockCostEditsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireInternalSaleNotesByDefault
     */
    updateCompanyShouldRequireInternalSaleNotesByDefault(input: UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes> {
        const method = this.methods[75], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldRequireInternalSaleNotesByDefaultReq, UpdateCompanyShouldRequireInternalSaleNotesByDefaultRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyPreserveSaleProductPriceEdits
     */
    updateCompanyPreserveSaleProductPriceEdits(input: UpdateCompanyPreserveSaleProductPriceEditsReq, options?: RpcOptions): UnaryCall<UpdateCompanyPreserveSaleProductPriceEditsReq, UpdateCompanyPreserveSaleProductPriceEditsRes> {
        const method = this.methods[76], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyPreserveSaleProductPriceEditsReq, UpdateCompanyPreserveSaleProductPriceEditsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyAllowDifferentFulfillmentLocation
     */
    updateCompanyAllowDifferentFulfillmentLocation(input: UpdateCompanyAllowDifferentFulfillmentLocationReq, options?: RpcOptions): UnaryCall<UpdateCompanyAllowDifferentFulfillmentLocationReq, UpdateCompanyAllowDifferentFulfillmentLocationRes> {
        const method = this.methods[77], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyAllowDifferentFulfillmentLocationReq, UpdateCompanyAllowDifferentFulfillmentLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldAutoApplyCreditsOnStatements
     */
    updateCompanyShouldAutoApplyCreditsOnStatements(input: UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, UpdateCompanyShouldAutoApplyCreditsOnStatementsRes> {
        const method = this.methods[78], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldAutoApplyCreditsOnStatementsReq, UpdateCompanyShouldAutoApplyCreditsOnStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireVoidReason
     */
    updateCompanyShouldRequireVoidReason(input: UpdateCompanyShouldRequireVoidReasonReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireVoidReasonReq, UpdateCompanyShouldRequireVoidReasonRes> {
        const method = this.methods[79], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldRequireVoidReasonReq, UpdateCompanyShouldRequireVoidReasonRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsDoubleSidedStatementPrintingEnabled
     */
    updateCompanyIsDoubleSidedStatementPrintingEnabled(input: UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes> {
        const method = this.methods[80], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsDoubleSidedStatementPrintingEnabledReq, UpdateCompanyIsDoubleSidedStatementPrintingEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldRequireCustomerOnSale
     */
    updateCompanyShouldRequireCustomerOnSale(input: UpdateCompanyShouldRequireCustomerOnSaleReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldRequireCustomerOnSaleReq, UpdateCompanyShouldRequireCustomerOnSaleRes> {
        const method = this.methods[81], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldRequireCustomerOnSaleReq, UpdateCompanyShouldRequireCustomerOnSaleRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyCustomEmailConfig
     */
    updateCompanyCustomEmailConfig(input: UpdateCompanyCustomEmailConfigReq, options?: RpcOptions): UnaryCall<UpdateCompanyCustomEmailConfigReq, UpdateCompanyCustomEmailConfigRes> {
        const method = this.methods[82], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyCustomEmailConfigReq, UpdateCompanyCustomEmailConfigRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ValidateCompanyCustomEmailConfig
     */
    validateCompanyCustomEmailConfig(input: ValidateCompanyCustomEmailConfigReq, options?: RpcOptions): UnaryCall<ValidateCompanyCustomEmailConfigReq, ValidateCompanyCustomEmailConfigRes> {
        const method = this.methods[83], opt = this._transport.mergeOptions(options);
        return stackIntercept<ValidateCompanyCustomEmailConfigReq, ValidateCompanyCustomEmailConfigRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyStartInventoryCountsAtOnHand
     */
    updateCompanyStartInventoryCountsAtOnHand(input: UpdateCompanyStartInventoryCountsAtOnHandReq, options?: RpcOptions): UnaryCall<UpdateCompanyStartInventoryCountsAtOnHandReq, UpdateCompanyStartInventoryCountsAtOnHandRes> {
        const method = this.methods[84], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyStartInventoryCountsAtOnHandReq, UpdateCompanyStartInventoryCountsAtOnHandRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsBankingPermitted
     */
    getIsBankingPermitted(input: GetIsBankingPermittedReq, options?: RpcOptions): UnaryCall<GetIsBankingPermittedReq, GetIsBankingPermittedRes> {
        const method = this.methods[85], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsBankingPermittedReq, GetIsBankingPermittedRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyIsPricingByRegionEnabled
     */
    updateCompanyIsPricingByRegionEnabled(input: UpdateCompanyIsPricingByRegionEnabledReq, options?: RpcOptions): UnaryCall<UpdateCompanyIsPricingByRegionEnabledReq, UpdateCompanyIsPricingByRegionEnabledRes> {
        const method = this.methods[86], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyIsPricingByRegionEnabledReq, UpdateCompanyIsPricingByRegionEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyProductImageSettings
     */
    updateCompanyProductImageSettings(input: UpdateCompanyProductImageSettingsReq, options?: RpcOptions): UnaryCall<UpdateCompanyProductImageSettingsReq, UpdateCompanyProductImageSettingsRes> {
        const method = this.methods[87], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyProductImageSettingsReq, UpdateCompanyProductImageSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyShouldHideNetZeroActivitiesOnStatements
     */
    updateCompanyShouldHideNetZeroActivitiesOnStatements(input: UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, options?: RpcOptions): UnaryCall<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes> {
        const method = this.methods[88], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyShouldHideNetZeroActivitiesOnStatementsReq, UpdateCompanyShouldHideNetZeroActivitiesOnStatementsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Tax Rates
     *
     * @generated from protobuf rpc: CreateCustomTaxRate
     */
    createCustomTaxRate(input: CreateCustomTaxRateReq, options?: RpcOptions): UnaryCall<CreateCustomTaxRateReq, CreateCustomTaxRateRes> {
        const method = this.methods[89], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCustomTaxRateReq, CreateCustomTaxRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomTaxRate
     */
    updateCustomTaxRate(input: UpdateCustomTaxRateReq, options?: RpcOptions): UnaryCall<UpdateCustomTaxRateReq, UpdateCustomTaxRateRes> {
        const method = this.methods[90], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomTaxRateReq, UpdateCustomTaxRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderCustomTaxRates
     */
    reorderCustomTaxRates(input: ReorderCustomTaxRatesReq, options?: RpcOptions): UnaryCall<ReorderCustomTaxRatesReq, ReorderCustomTaxRatesRes> {
        const method = this.methods[91], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderCustomTaxRatesReq, ReorderCustomTaxRatesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateCustomTaxRate
     */
    deactivateCustomTaxRate(input: DeactivateCustomTaxRateReq, options?: RpcOptions): UnaryCall<DeactivateCustomTaxRateReq, DeactivateCustomTaxRateRes> {
        const method = this.methods[92], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateCustomTaxRateReq, DeactivateCustomTaxRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListTaxRatesForCompany
     */
    listTaxRatesForCompany(input: ListTaxRatesForCompanyReq, options?: RpcOptions): UnaryCall<ListTaxRatesForCompanyReq, ListTaxRatesForCompanyRes> {
        const method = this.methods[93], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListTaxRatesForCompanyReq, ListTaxRatesForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListTaxRatesForLocation
     */
    listTaxRatesForLocation(input: ListTaxRatesForLocationReq, options?: RpcOptions): UnaryCall<ListTaxRatesForLocationReq, ListTaxRatesForLocationRes> {
        const method = this.methods[94], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListTaxRatesForLocationReq, ListTaxRatesForLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetOrCreateCustomTaxRateForAddress
     */
    getOrCreateCustomTaxRateForAddress(input: GetOrCreateCustomTaxRateForAddressReq, options?: RpcOptions): UnaryCall<GetOrCreateCustomTaxRateForAddressReq, GetOrCreateCustomTaxRateForAddressRes> {
        const method = this.methods[95], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrCreateCustomTaxRateForAddressReq, GetOrCreateCustomTaxRateForAddressRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Units of Measure
     *
     * @generated from protobuf rpc: AddCompanyUnitOfMeasure
     */
    addCompanyUnitOfMeasure(input: AddCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<AddCompanyUnitOfMeasureReq, AddCompanyUnitOfMeasureRes> {
        const method = this.methods[96], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddCompanyUnitOfMeasureReq, AddCompanyUnitOfMeasureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCompanyUnitOfMeasure
     */
    updateCompanyUnitOfMeasure(input: UpdateCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<UpdateCompanyUnitOfMeasureReq, UpdateCompanyUnitOfMeasureRes> {
        const method = this.methods[97], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCompanyUnitOfMeasureReq, UpdateCompanyUnitOfMeasureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCompanyUnitOfMeasure
     */
    deleteCompanyUnitOfMeasure(input: DeleteCompanyUnitOfMeasureReq, options?: RpcOptions): UnaryCall<DeleteCompanyUnitOfMeasureReq, DeleteCompanyUnitOfMeasureRes> {
        const method = this.methods[98], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteCompanyUnitOfMeasureReq, DeleteCompanyUnitOfMeasureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertUnitsOfMeasure
     */
    bulkUpsertUnitsOfMeasure(input: BulkUpsertUnitsOfMeasureReq, options?: RpcOptions): UnaryCall<BulkUpsertUnitsOfMeasureReq, BulkUpsertUnitsOfMeasureRes> {
        const method = this.methods[99], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertUnitsOfMeasureReq, BulkUpsertUnitsOfMeasureRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListUnitsOfMeasureForCompany
     */
    listUnitsOfMeasureForCompany(input: ListUnitsOfMeasureForCompanyReq, options?: RpcOptions): UnaryCall<ListUnitsOfMeasureForCompanyReq, ListUnitsOfMeasureForCompanyRes> {
        const method = this.methods[100], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListUnitsOfMeasureForCompanyReq, ListUnitsOfMeasureForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CanEditSaleUom
     */
    canEditSaleUom(input: CanEditSaleUomReq, options?: RpcOptions): UnaryCall<CanEditSaleUomReq, CanEditSaleUomRes> {
        const method = this.methods[101], opt = this._transport.mergeOptions(options);
        return stackIntercept<CanEditSaleUomReq, CanEditSaleUomRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Stripe
     *
     * @generated from protobuf rpc: GetStripeOnboardingURL
     */
    getStripeOnboardingURL(input: GetStripeOnboardingURLReq, options?: RpcOptions): UnaryCall<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes> {
        const method = this.methods[102], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStripeCustomOnboardingURL
     */
    getStripeCustomOnboardingURL(input: GetStripeOnboardingURLReq, options?: RpcOptions): UnaryCall<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes> {
        const method = this.methods[103], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStripeOnboardingURLReq, GetStripeOnboardingURLRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStripeLoginURL
     */
    getStripeLoginURL(input: GetStripeLoginURLReq, options?: RpcOptions): UnaryCall<GetStripeLoginURLReq, GetStripeLoginURLRes> {
        const method = this.methods[104], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStripeLoginURLReq, GetStripeLoginURLRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetStripeAccountSession
     */
    getStripeAccountSession(input: GetStripeAccountSessionReq, options?: RpcOptions): UnaryCall<GetStripeAccountSessionReq, GetStripeAccountSessionRes> {
        const method = this.methods[105], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetStripeAccountSessionReq, GetStripeAccountSessionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsStripePaymentsReady
     */
    getIsStripePaymentsReady(input: GetIsStripePaymentsReadyReq, options?: RpcOptions): UnaryCall<GetIsStripePaymentsReadyReq, GetIsStripePaymentsReadyRes> {
        const method = this.methods[106], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsStripePaymentsReadyReq, GetIsStripePaymentsReadyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCardSetupIntentForEntity
     */
    createCardSetupIntentForEntity(input: CreateCardSetupIntentForEntityReq, options?: RpcOptions): UnaryCall<CreateCardSetupIntentForEntityReq, CreateCardSetupIntentForEntityRes> {
        const method = this.methods[107], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCardSetupIntentForEntityReq, CreateCardSetupIntentForEntityRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEntityBillingInfo
     */
    getEntityBillingInfo(input: GetEntityBillingInfoReq, options?: RpcOptions): UnaryCall<GetEntityBillingInfoReq, GetEntityBillingInfoRes> {
        const method = this.methods[108], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetEntityBillingInfoReq, GetEntityBillingInfoRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetNeedsBillingPaymentMethod
     */
    getNeedsBillingPaymentMethod(input: GetNeedsBillingPaymentMethodReq, options?: RpcOptions): UnaryCall<GetNeedsBillingPaymentMethodReq, GetNeedsBillingPaymentMethodRes> {
        const method = this.methods[109], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetNeedsBillingPaymentMethodReq, GetNeedsBillingPaymentMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetEntityDefaultPaymentMethod
     */
    setEntityDefaultPaymentMethod(input: SetEntityDefaultPaymentMethodReq, options?: RpcOptions): UnaryCall<SetEntityDefaultPaymentMethodReq, SetEntityDefaultPaymentMethodRes> {
        const method = this.methods[110], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetEntityDefaultPaymentMethodReq, SetEntityDefaultPaymentMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Agreements
     *
     * @generated from protobuf rpc: ListAgreementsForCompany
     */
    listAgreementsForCompany(input: ListAgreementsForCompanyReq, options?: RpcOptions): UnaryCall<ListAgreementsForCompanyReq, ListAgreementsForCompanyRes> {
        const method = this.methods[111], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAgreementsForCompanyReq, ListAgreementsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAgreementPDFForCompany
     */
    getAgreementPDFForCompany(input: GetAgreementPDFForCompanyReq, options?: RpcOptions): UnaryCall<GetAgreementPDFForCompanyReq, GetAgreementPDFForCompanyRes> {
        const method = this.methods[112], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAgreementPDFForCompanyReq, GetAgreementPDFForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Additional Fees
     *
     * @generated from protobuf rpc: CreateAdditionalFee
     */
    createAdditionalFee(input: CreateAdditionalFeeReq, options?: RpcOptions): UnaryCall<CreateAdditionalFeeReq, CreateAdditionalFeeRes> {
        const method = this.methods[113], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAdditionalFeeReq, CreateAdditionalFeeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateAdditionalFee
     */
    updateAdditionalFee(input: UpdateAdditionalFeeReq, options?: RpcOptions): UnaryCall<UpdateAdditionalFeeReq, UpdateAdditionalFeeRes> {
        const method = this.methods[114], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateAdditionalFeeReq, UpdateAdditionalFeeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAdditionalFee
     */
    deleteAdditionalFee(input: DeleteAdditionalFeeReq, options?: RpcOptions): UnaryCall<DeleteAdditionalFeeReq, DeleteAdditionalFeeRes> {
        const method = this.methods[115], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAdditionalFeeReq, DeleteAdditionalFeeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderAdditionalFees
     */
    reorderAdditionalFees(input: ReorderAdditionalFeesReq, options?: RpcOptions): UnaryCall<ReorderAdditionalFeesReq, ReorderAdditionalFeesRes> {
        const method = this.methods[116], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderAdditionalFeesReq, ReorderAdditionalFeesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAdditionalFeesForCompany
     */
    listAdditionalFeesForCompany(input: ListAdditionalFeesForCompanyReq, options?: RpcOptions): UnaryCall<ListAdditionalFeesForCompanyReq, ListAdditionalFeesForCompanyRes> {
        const method = this.methods[117], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAdditionalFeesForCompanyReq, ListAdditionalFeesForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListProductsForFee
     */
    listProductsForFee(input: ListProductsForFeeReq, options?: RpcOptions): UnaryCall<ListProductsForFeeReq, ListProductsForFeeRes> {
        const method = this.methods[118], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListProductsForFeeReq, ListProductsForFeeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDefaultPaintCareFees
     */
    getDefaultPaintCareFees(input: GetDefaultPaintCareFeesReq, options?: RpcOptions): UnaryCall<GetDefaultPaintCareFeesReq, GetDefaultPaintCareFeesRes> {
        const method = this.methods[119], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDefaultPaintCareFeesReq, GetDefaultPaintCareFeesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Product Categories V2
     *
     * @generated from protobuf rpc: CreateProductCategoryV2
     */
    createProductCategoryV2(input: CreateProductCategoryV2Req, options?: RpcOptions): UnaryCall<CreateProductCategoryV2Req, CreateProductCategoryV2Res> {
        const method = this.methods[120], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateProductCategoryV2Req, CreateProductCategoryV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateProductCategoryV2
     */
    updateProductCategoryV2(input: UpdateProductCategoryV2Req, options?: RpcOptions): UnaryCall<UpdateProductCategoryV2Req, UpdateProductCategoryV2Res> {
        const method = this.methods[121], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateProductCategoryV2Req, UpdateProductCategoryV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListProductCategoriesForCompanyV2
     */
    listProductCategoriesForCompanyV2(input: ListProductCategoriesForCompanyV2Req, options?: RpcOptions): UnaryCall<ListProductCategoriesForCompanyV2Req, ListProductCategoriesForCompanyV2Res> {
        const method = this.methods[122], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListProductCategoriesForCompanyV2Req, ListProductCategoriesForCompanyV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListProductsForCategoryV2
     */
    listProductsForCategoryV2(input: ListProductsForCategoryV2Req, options?: RpcOptions): UnaryCall<ListProductsForCategoryV2Req, ListProductsForCategoryV2Res> {
        const method = this.methods[123], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListProductsForCategoryV2Req, ListProductsForCategoryV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProductCategoryTree
     */
    getProductCategoryTree(input: GetProductCategoryTreeReq, options?: RpcOptions): UnaryCall<GetProductCategoryTreeReq, GetProductCategoryTreeRes> {
        const method = this.methods[124], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetProductCategoryTreeReq, GetProductCategoryTreeRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateProductCategoryV2
     */
    deactivateProductCategoryV2(input: DeactivateProductCategoryV2Req, options?: RpcOptions): UnaryCall<DeactivateProductCategoryV2Req, DeactivateProductCategoryV2Res> {
        const method = this.methods[125], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateProductCategoryV2Req, DeactivateProductCategoryV2Res>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertDepartments
     */
    bulkUpsertDepartments(input: BulkUpsertDepartmentsReq, options?: RpcOptions): UnaryCall<BulkUpsertDepartmentsReq, BulkUpsertDepartmentsRes> {
        const method = this.methods[126], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertDepartmentsReq, BulkUpsertDepartmentsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertClasses
     */
    bulkUpsertClasses(input: BulkUpsertClassesReq, options?: RpcOptions): UnaryCall<BulkUpsertClassesReq, BulkUpsertClassesRes> {
        const method = this.methods[127], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertClassesReq, BulkUpsertClassesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertFinelines
     */
    bulkUpsertFinelines(input: BulkUpsertFinelineReq, options?: RpcOptions): UnaryCall<BulkUpsertFinelineReq, BulkUpsertFinelineRes> {
        const method = this.methods[128], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertFinelineReq, BulkUpsertFinelineRes>("unary", this._transport, method, opt, input);
    }
    /**
     * FinancingTerms
     *
     * @generated from protobuf rpc: CreateFinancingTerm
     */
    createFinancingTerm(input: CreateFinancingTermReq, options?: RpcOptions): UnaryCall<CreateFinancingTermReq, CreateFinancingTermRes> {
        const method = this.methods[129], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateFinancingTermReq, CreateFinancingTermRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateFinancingTerm
     */
    updateFinancingTerm(input: UpdateFinancingTermReq, options?: RpcOptions): UnaryCall<UpdateFinancingTermReq, UpdateFinancingTermRes> {
        const method = this.methods[130], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateFinancingTermReq, UpdateFinancingTermRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteFinancingTerm
     */
    deleteFinancingTerm(input: DeleteFinancingTermReq, options?: RpcOptions): UnaryCall<DeleteFinancingTermReq, DeleteFinancingTermRes> {
        const method = this.methods[131], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteFinancingTermReq, DeleteFinancingTermRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderFinancingTerms
     */
    reorderFinancingTerms(input: ReorderFinancingTermsReq, options?: RpcOptions): UnaryCall<ReorderFinancingTermsReq, ReorderFinancingTermsRes> {
        const method = this.methods[132], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderFinancingTermsReq, ReorderFinancingTermsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListFinancingTermsForCompany
     */
    listFinancingTermsForCompany(input: ListFinancingTermsForCompanyReq, options?: RpcOptions): UnaryCall<ListFinancingTermsForCompanyReq, ListFinancingTermsForCompanyRes> {
        const method = this.methods[133], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListFinancingTermsForCompanyReq, ListFinancingTermsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCustomersForTerm
     */
    listCustomersForTerm(input: ListCustomersForTermReq, options?: RpcOptions): UnaryCall<ListCustomersForTermReq, ListCustomersForTermRes> {
        const method = this.methods[134], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCustomersForTermReq, ListCustomersForTermRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Pricing Tiers
     *
     * @generated from protobuf rpc: CreatePricingTier
     */
    createPricingTier(input: CreatePricingTierReq, options?: RpcOptions): UnaryCall<CreatePricingTierReq, CreatePricingTierRes> {
        const method = this.methods[135], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePricingTierReq, CreatePricingTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePricingTier
     */
    updatePricingTier(input: UpdatePricingTierReq, options?: RpcOptions): UnaryCall<UpdatePricingTierReq, UpdatePricingTierRes> {
        const method = this.methods[136], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePricingTierReq, UpdatePricingTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeletePricingTier
     */
    deletePricingTier(input: DeletePricingTierReq, options?: RpcOptions): UnaryCall<DeletePricingTierReq, DeletePricingTierRes> {
        const method = this.methods[137], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePricingTierReq, DeletePricingTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderPricingTiers
     */
    reorderPricingTiers(input: ReorderPricingTiersReq, options?: RpcOptions): UnaryCall<ReorderPricingTiersReq, ReorderPricingTiersRes> {
        const method = this.methods[138], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderPricingTiersReq, ReorderPricingTiersRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPricingTiersForCompany
     */
    listPricingTiersForCompany(input: ListPricingTiersForCompanyReq, options?: RpcOptions): UnaryCall<ListPricingTiersForCompanyReq, ListPricingTiersForCompanyRes> {
        const method = this.methods[139], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPricingTiersForCompanyReq, ListPricingTiersForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCustomersForTier
     */
    listCustomersForTier(input: ListCustomersForTierReq, options?: RpcOptions): UnaryCall<ListCustomersForTierReq, ListCustomersForTierRes> {
        const method = this.methods[140], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCustomersForTierReq, ListCustomersForTierRes>("unary", this._transport, method, opt, input);
    }
    /**
     * User
     *
     * @generated from protobuf rpc: GetCurrentUser
     */
    getCurrentUser(input: GetCurrentUserReq, options?: RpcOptions): UnaryCall<GetCurrentUserReq, GetCurrentUserRes> {
        const method = this.methods[141], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCurrentUserReq, GetCurrentUserRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCurrentUserIsAttributionEnabled
     */
    getCurrentUserIsAttributionEnabled(input: GetCurrentUserIsAttributionEnabledReq, options?: RpcOptions): UnaryCall<GetCurrentUserIsAttributionEnabledReq, GetCurrentUserIsAttributionEnabledRes> {
        const method = this.methods[142], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCurrentUserIsAttributionEnabledReq, GetCurrentUserIsAttributionEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Credit Card
     *
     * @generated from protobuf rpc: UpdateCardSurchargeRate
     */
    updateCardSurchargeRate(input: UpdateCardSurchargeRateReq, options?: RpcOptions): UnaryCall<UpdateCardSurchargeRateReq, UpdateCardSurchargeRateRes> {
        const method = this.methods[143], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCardSurchargeRateReq, UpdateCardSurchargeRateRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Roles
     *
     * @generated from protobuf rpc: GetPermissionsGroups
     */
    getPermissionsGroups(input: GetPermissionsGroupsReq, options?: RpcOptions): UnaryCall<GetPermissionsGroupsReq, GetPermissionsGroupsRes> {
        const method = this.methods[144], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPermissionsGroupsReq, GetPermissionsGroupsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Finance Charge Settings
     *
     * @generated from protobuf rpc: CreateFinanceChargeSetting
     */
    createFinanceChargeSetting(input: CreateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<CreateFinanceChargeSettingReq, CreateFinanceChargeSettingRes> {
        const method = this.methods[145], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateFinanceChargeSettingReq, CreateFinanceChargeSettingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateFinanceChargeSetting
     */
    updateFinanceChargeSetting(input: UpdateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<UpdateFinanceChargeSettingReq, UpdateFinanceChargeSettingRes> {
        const method = this.methods[146], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateFinanceChargeSettingReq, UpdateFinanceChargeSettingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListActiveFinanceChargeSettingsForCompany
     */
    listActiveFinanceChargeSettingsForCompany(input: ListActiveFinanceChargeSettingsForCompanyReq, options?: RpcOptions): UnaryCall<ListActiveFinanceChargeSettingsForCompanyReq, ListActiveFinanceChargeSettingsForCompanyRes> {
        const method = this.methods[147], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListActiveFinanceChargeSettingsForCompanyReq, ListActiveFinanceChargeSettingsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCustomersForFinanceChargeSetting
     */
    listCustomersForFinanceChargeSetting(input: ListCustomersForFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<ListCustomersForFinanceChargeSettingReq, ListCustomersForFinanceChargeSettingRes> {
        const method = this.methods[148], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCustomersForFinanceChargeSettingReq, ListCustomersForFinanceChargeSettingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateFinanceChargeSetting
     */
    deactivateFinanceChargeSetting(input: DeactivateFinanceChargeSettingReq, options?: RpcOptions): UnaryCall<DeactivateFinanceChargeSettingReq, DeactivateFinanceChargeSettingRes> {
        const method = this.methods[149], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateFinanceChargeSettingReq, DeactivateFinanceChargeSettingRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderFinanceChargeSettings
     */
    reorderFinanceChargeSettings(input: ReorderFinanceChargeSettingsReq, options?: RpcOptions): UnaryCall<ReorderFinanceChargeSettingsReq, ReorderFinanceChargeSettingsRes> {
        const method = this.methods[150], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderFinanceChargeSettingsReq, ReorderFinanceChargeSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Cost Management
     *
     * @generated from protobuf rpc: UpdateCostManagementSettings
     */
    updateCostManagementSettings(input: UpdateCostManagementSettingsReq, options?: RpcOptions): UnaryCall<UpdateCostManagementSettingsReq, UpdateCostManagementSettingsRes> {
        const method = this.methods[151], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCostManagementSettingsReq, UpdateCostManagementSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Sale Forms
     *
     * @generated from protobuf rpc: CreateSaleForm
     */
    createSaleForm(input: CreateSaleFormReq, options?: RpcOptions): UnaryCall<CreateSaleFormReq, CreateSaleFormRes> {
        const method = this.methods[152], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSaleFormReq, CreateSaleFormRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSaleForm
     */
    updateSaleForm(input: UpdateSaleFormReq, options?: RpcOptions): UnaryCall<UpdateSaleFormReq, UpdateSaleFormRes> {
        const method = this.methods[153], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSaleFormReq, UpdateSaleFormRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListSaleForms
     */
    listSaleForms(input: ListSaleFormsReq, options?: RpcOptions): UnaryCall<ListSaleFormsReq, ListSaleFormsRes> {
        const method = this.methods[154], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSaleFormsReq, ListSaleFormsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteSaleForm
     */
    deleteSaleForm(input: DeleteSaleFormReq, options?: RpcOptions): UnaryCall<DeleteSaleFormReq, DeleteSaleFormRes> {
        const method = this.methods[155], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteSaleFormReq, DeleteSaleFormRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Entities
     *
     * @generated from protobuf rpc: ListEntitiesForCompany
     */
    listEntitiesForCompany(input: ListEntitiesForCompanyReq, options?: RpcOptions): UnaryCall<ListEntitiesForCompanyReq, ListEntitiesForCompanyRes> {
        const method = this.methods[156], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListEntitiesForCompanyReq, ListEntitiesForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Methods
     *
     * @generated from protobuf rpc: ListDrawerMethods
     */
    listDrawerMethods(input: ListDrawerMethodsReq, options?: RpcOptions): UnaryCall<ListDrawerMethodsReq, ListDrawerMethodsRes> {
        const method = this.methods[157], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDrawerMethodsReq, ListDrawerMethodsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCustomTenderMethod
     */
    createCustomTenderMethod(input: CreateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<CreateCustomTenderMethodReq, CreateCustomTenderMethodRes> {
        const method = this.methods[158], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCustomTenderMethodReq, CreateCustomTenderMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCustomTenderMethod
     */
    updateCustomTenderMethod(input: UpdateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<UpdateCustomTenderMethodReq, UpdateCustomTenderMethodRes> {
        const method = this.methods[159], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCustomTenderMethodReq, UpdateCustomTenderMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDefaultTenderMethodUsages
     */
    updateDefaultTenderMethodUsages(input: UpdateDefaultTenderMethodUsagesReq, options?: RpcOptions): UnaryCall<UpdateDefaultTenderMethodUsagesReq, UpdateDefaultTenderMethodUsagesRes> {
        const method = this.methods[160], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDefaultTenderMethodUsagesReq, UpdateDefaultTenderMethodUsagesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateCustomTenderMethod
     */
    deactivateCustomTenderMethod(input: DeactivateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<DeactivateCustomTenderMethodReq, DeactivateCustomTenderMethodRes> {
        const method = this.methods[161], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateCustomTenderMethodReq, DeactivateCustomTenderMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ActivateCustomTenderMethod
     */
    activateCustomTenderMethod(input: ActivateCustomTenderMethodReq, options?: RpcOptions): UnaryCall<ActivateCustomTenderMethodReq, ActivateCustomTenderMethodRes> {
        const method = this.methods[162], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActivateCustomTenderMethodReq, ActivateCustomTenderMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderTenderMethods
     */
    reorderTenderMethods(input: ReorderTenderMethodsReq, options?: RpcOptions): UnaryCall<ReorderTenderMethodsReq, ReorderTenderMethodsRes> {
        const method = this.methods[163], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderTenderMethodsReq, ReorderTenderMethodsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetActiveTenderMethodCount
     */
    getActiveTenderMethodCount(input: GetActiveTenderMethodCountReq, options?: RpcOptions): UnaryCall<GetActiveTenderMethodCountReq, GetActiveTenderMethodCountRes> {
        const method = this.methods[164], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveTenderMethodCountReq, GetActiveTenderMethodCountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIsGiftCardsEnabled
     */
    getIsGiftCardsEnabled(input: GetIsGiftCardsEnabledReq, options?: RpcOptions): UnaryCall<GetIsGiftCardsEnabledReq, GetIsGiftCardsEnabledRes> {
        const method = this.methods[165], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIsGiftCardsEnabledReq, GetIsGiftCardsEnabledRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Pricing Regions
     *
     * @generated from protobuf rpc: CreatePricingRegion
     */
    createPricingRegion(input: CreatePricingRegionReq, options?: RpcOptions): UnaryCall<CreatePricingRegionReq, CreatePricingRegionRes> {
        const method = this.methods[166], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePricingRegionReq, CreatePricingRegionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePricingRegionName
     */
    updatePricingRegionName(input: UpdatePricingRegionNameReq, options?: RpcOptions): UnaryCall<UpdatePricingRegionNameReq, UpdatePricingRegionNameRes> {
        const method = this.methods[167], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePricingRegionNameReq, UpdatePricingRegionNameRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateDefaultPricingRegion
     */
    updateDefaultPricingRegion(input: UpdateDefaultPricingRegionReq, options?: RpcOptions): UnaryCall<UpdateDefaultPricingRegionReq, UpdateDefaultPricingRegionRes> {
        const method = this.methods[168], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateDefaultPricingRegionReq, UpdateDefaultPricingRegionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivatePricingRegion
     */
    deactivatePricingRegion(input: DeactivatePricingRegionReq, options?: RpcOptions): UnaryCall<DeactivatePricingRegionReq, DeactivatePricingRegionRes> {
        const method = this.methods[169], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivatePricingRegionReq, DeactivatePricingRegionRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReorderPricingRegions
     */
    reorderPricingRegions(input: ReorderPricingRegionsReq, options?: RpcOptions): UnaryCall<ReorderPricingRegionsReq, ReorderPricingRegionsRes> {
        const method = this.methods[170], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReorderPricingRegionsReq, ReorderPricingRegionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPricingRegionsForCompany
     */
    listPricingRegionsForCompany(input: ListPricingRegionsForCompanyReq, options?: RpcOptions): UnaryCall<ListPricingRegionsForCompanyReq, ListPricingRegionsForCompanyRes> {
        const method = this.methods[171], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPricingRegionsForCompanyReq, ListPricingRegionsForCompanyRes>("unary", this._transport, method, opt, input);
    }
}
